<template>
  <div class="filter-box" v-show="visible">
    <div class="filter-content">
      <!-- form -->
      <div class="search-form">
        <div class="form-item">
          <div class="form-label">人群名称：</div>
          <div class="form-value">
            <!-- size="small" -->
            <el-input style="width: 250px" v-model="form.name" placeholder="请输入人群名称" maxlength="60" show-word-limit></el-input>
          </div>
        </div>
        <div class="form-item" style="margin-left: 20px">
          <div class="form-label">人群描述：</div>
          <div class="form-value">
            <!-- size="small" -->
            <el-input
              :style="'width:' + inputWidth + 'px'"
              v-model="form.description"
              placeholder="请输入人群描述"
              maxlength="50"
              show-word-limit
            ></el-input>
          </div>
        </div>
        <div class="form-item" style="margin-left: 20px">
          <div class="form-label">选择分类：</div>
          <div style="display:inline-block">
            <!-- size="small" -->
            <!-- <el-select v-model="form.type" @change="handleChangeType">
              <el-option :value="1" label="自定义人群"></el-option>
              <el-option :value="13" label="互动人群"></el-option>
            </el-select> -->
            <!-- <el-select v-model="form.classifyId" style="margin-left: 8px">
              <el-option :value="0" label="默认分组"></el-option>
              <template v-if="form.type == 1">
                <el-option
                  v-for="(item, index) in customClassifyOptions"
                  :key="index"
                  :value="item.classifyId"
                  :label="item.name"
                >
                </el-option>
              </template>
              <template v-else-if="form.type == 13">
                <el-option
                  v-for="(item, index) in hdClassifyOptions"
                  :key="index"
                  :value="item.classifyId"
                  :label="item.name"
                >
                </el-option>
              </template>
            </el-select> -->
            <el-cascader
              style="width:320px"
              v-model="form.classifyId"
              :options="customClassifyOptions"
              :show-all-levels="false"
              :props="{checkStrictly: true, emitPath: false, expandTrigger: 'hover', value: 'id',label: 'name' }"
            >
            </el-cascader>
          </div>
        </div>
      </div>
      <!-- 提示 -->
      <div class="tip-line" style="margin-top: 10px;background:#FAFAFA;padding:5px 0;">
        <img
          src="@/assets/images/new_icon_reminder.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 0 4px 0 3px;
          "
        />
        <span style="color: #fe4d45">注意：标签数据的用户范围为“开卡会员或已购用户”</span>
      </div>
      <div class="attr-box">
        <!-- 左侧标签菜单 -->
        <div class="attr-leftbigProbox">
          <div class="search-line">
            <el-input v-model="searchValue" @keyup.enter.native="handleSearch" placeholder="请输入标签名称查询"></el-input>
            <i class="el-icon-search" @click="handleSearch"></i>
          </div>
          <div class="attr-leftbigTabbox">
            <div
              class="attr-itemPro-wrap"
              :class="{ 'attr-itemPro-wrapClick': leftWarpTitle == '常用标签' }"
              :key="'wrap' + 666666"
              @click="handleWrap({firstLevelCategory:'常用标签'})"
              v-show="isCommonShow"
            >
              <span>常用标签</span>
            </div>
            <div
              class="attr-itemPro-wrap"
              :class="{ 'attr-itemPro-wrapClick': leftWarpTitle == item.firstLevelCategory }"
              v-for="(item, index) in dataList"
              :key="'wrap' + index"
              @click="handleWrap(item)"
              v-show="item.searchWrap&&filterCategory(item.firstLevelCategory)"
            >
              <span>{{ item.firstLevelCategory }}</span>
            </div>
          </div>
        </div>
        <!-- 左侧标签列表 -->
        <div class="attr-leftbigbox">
          <div class="attr-left" id="scrollEle">
            <div class="search-result" v-if="searchStatus">
              <span>查询结果</span>
              <span class="go-back" @click="goBack">
                返回
                <i class="el-icon-close"></i>
              </span>
            </div>
            <!-- 无数据提示 -->
            <div v-if="isNoData" class="noData">
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px;color: #909399;">暂无任何数据</span>
            </div>
            <!-- 常用标签 -->
            <div
              class="attr-item-wrap"
              :key="'wrap' + 7777"
              v-show="isCommonShow"
            >
              <h4 class="anchorPoint" id="常用标签">
                常用标签
                <span style="color: #fe4d45; font-size: 13px">{{ recentlyList.length+commonUseList.length }}</span>
              </h4>
              <!-- 最近使用 -->
              <div
                class="attr-item-box"
              >
                <div class="attr-title">
                  <span style="font-weight:bold">最近使用</span>
                  <el-popover
                    placement="right"
                    width="240"
                    trigger="hover"
                    popper-class="popoverTips"
                  >
                    <span>展示近1年使用次数top10的标签</span>
                    <img src="@/assets/images/u103.png" style="width: 17px;position: relative;left: 5px;top: 3px;"  slot="reference">
                  </el-popover>
                </div>
                <div class="attr-list">
                  <template v-for="(item, idx) in recentlyList" >
                      <div class="attr-padd" v-if="item.searchItem && !hideLabelByMemberType(item)" :key="'label' + idx">
                        <!-- 标签点击 -->
                        <div
                          class="attr-item"
                          v-labelZoom="{ name: item.labelMeaning }"
                          :class="{ active: item.valueData.visible }"
                          @click="attrClickTop(item)"
                        >
                          <template v-if="item.labelMeaning.length >= 10">
                            <el-tooltip ref="tooltipRef" effect="light" :content="item.labelMeaning" placement="top-start" popper-class="toolTipSet" :hide-after="0" :open-delay="380">
                                <div class="over-ellipsis">
                                  <span class="icon-dot" v-if="item.isNew"></span>
                                  {{ item.labelMeaning }}
                                </div>
                            </el-tooltip>
                          </template>
                          <template v-else>
                              <div>
                                <span class="icon-dot" v-if="item.isNew"></span>
                                {{ item.labelMeaning }}
                              </div>
                          </template>
                          <img alt src="@/assets/images/gou.png" />
                        </div>
                      </div>
                  </template>
                </div>
              </div>
              <!-- 自定义设置 -->
              <div
                class="attr-item-box"
              >
                <div class="attr-title">
                  <span style="font-weight:bold">自定义设置</span>
                </div>
                <div class="attr-list">
                  <template v-for="(item, idx) in commonUseList" >
                      <div class="attr-padd" v-if="item.searchItem && !hideLabelByMemberType(item)" :key="'label' + idx">
                        <!-- 标签点击 -->
                        <div
                          class="attr-item"
                          v-labelZoom="{ name: item.labelMeaning }"
                          :class="{ active: item.valueData.visible }"
                          @click="attrClickTop(item)"
                        >
                          <template v-if="item.labelMeaning.length >= 10">
                            <el-tooltip ref="tooltipRef" effect="light" :content="item.labelMeaning" placement="top-start" popper-class="toolTipSet" :hide-after="0" :open-delay="380">
                              <el-popover
                                placement="right"
                                width="100"
                                trigger="hover"
                                popper-class="popoverSet"
                                :close-delay="100"
                                :open-delay="350"
                                ref="popoverRef"
                              >
                                <div class="over-ellipsis" slot="reference">
                                  <span class="icon-dot" v-if="item.isNew"></span>
                                  {{ item.labelMeaning }}
                                </div>
                                <div class="tips">
                                  <span class="noCommon" v-if="item.commonUse" @click="setCommonUse(item,0)">
                                    <img src="@/assets/images/取消常用.png" alt="">
                                    取消常用
                                  </span>
                                </div>
                              </el-popover>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <el-popover
                                placement="right"
                                width="100"
                                trigger="hover"
                                popper-class="popoverSet"
                                :close-delay="1"
                                :open-delay="350"
                                ref="popoverRef"
                              >
                              <div slot="reference">
                                <span class="icon-dot" v-if="item.isNew"></span>
                                {{ item.labelMeaning }}
                              </div>
                              <div class="tips">
                                <span class="noCommon" v-if="item.commonUse" @click="setCommonUse(item,0)">
                                  <img src="@/assets/images/取消常用.png" alt="">
                                  取消常用
                                </span>
                              </div>
                            </el-popover>
                          </template>
                          <img alt src="@/assets/images/gou.png" />
                        </div>
                      </div>
                  </template>
                </div>
              </div>
            </div>
            <!-- 标签菜单 -->
            <div
              class="attr-item-wrap"
              :class="{ attrActive: filterCategory(item.firstLevelCategory) == false }"
              v-for="(item, index) in dataList"
              :key="'wrap' + index"
              v-show="item.searchWrap"
            >
              <h4 v-show="filterCategory(item.firstLevelCategory)" class="anchorPoint" :id="item.firstLevelCategory">
                {{ item.firstLevelCategory }}
                <span v-if="item.firstLevelCategory == '品类标签'" style="color: #fe4d45; font-size: 13px">{{ item.labelCount - 3 }}</span>
                <span v-else-if="item.firstLevelCategory == '品牌标签'" style="color: #fe4d45; font-size: 13px">{{ item.labelCount - 1 }}</span>
                <span v-else style="color: #fe4d45; font-size: 13px">{{ item.labelCount }}</span>
                <img
                  src="@/assets/images/tag_gaoji.svg"
                  style="width:50px;margin-left:2px"
                  v-if="item.firstLevelCategory == '品牌标签' && (advanced[0] == 'hide:brand:tag' || advanced[1] == 'hide:brand:tag')"
                />
                <img
                  src="@/assets/images/tag_gaoji.svg"
                  style="width:50px;margin-left:2px"
                  v-if="item.firstLevelCategory == '品类标签' && (advanced[0] == 'hide:cate:tag' || advanced[1] == 'hide:cate:tag')"
                />
                <!-- <img
                  src="@/assets/images/tag_gaoji.svg"
                  style="width:50px;margin-left:2px"
                  v-if="item.firstLevelCategory == '互动标签' && (advanced[0] == ' hide:interaction:tag' || advanced[1] == ' hide:interaction:tag')"
                /> -->
                <el-tooltip v-if="item.firstLevelCategory == '互动标签'" class="item" effect="dark"
                  content="互动标签仅支持同步参与【京获客】互动且已开卡的人群，如需同步所有互动用户建议创建活动时设置仅限会员参与"
                  placement="bottom">
                  <img src="@/assets/images/ask.png" alt="" style="margin-bottom: -3px;margin-left:3px; cursor: pointer" />
                </el-tooltip>
              </h4>

              <div
                v-show="filterCategory(item.firstLevelCategory)"
                class="attr-item-box"
                v-for="(labelItem, labelIndex) in item.data"
                :key="labelIndex"
              >
                <div class="attr-title" v-show="labelItem.searchTitle">
                  <span style="font-weight:bold">{{ labelItem.secondLevelCategory }}</span>
                  <img v-if="isNewImg(labelItem.secondLevelCategory)" src="@/assets/images/tag_new_x.png" alt="" />
                </div>

                <div class="attr-list">
                  <template v-for="(label, idx) in labelItem.data">
                    <span v-show="filterCategory(label.labelMeaning)" :key="'label' + idx">
                      <div class="attr-padd" v-if="label.searchItem && !hideLabelByMemberType(label)">
                        <!-- 标签点击 -->
                        <div
                          class="attr-item "
                          id="popoverEl"
                          v-labelZoom="{ name: label.labelMeaning }"
                          :class="{ active: label.valueData.visible }"
                          @click="attrClick(label, item, labelItem)"
                        >
                          <template v-if="label.labelMeaning.length >= 10">
                            <el-tooltip ref="tooltipRef" effect="light" :content="label.labelMeaning" placement="top-start" popper-class="toolTipSet" :hide-after="0" :open-delay="400">
                              <el-popover
                                placement="right"
                                width="100"
                                trigger="hover"
                                popper-class="popoverSet"
                                :close-delay="100"
                                :open-delay="350"
                                ref="popoverRef"
                                :offset="0"
                              >
                                <div class="over-ellipsis" slot="reference">
                                  <span class="icon-dot" v-if="label.isNew"></span>
                                  {{ label.labelMeaning }}
                                </div>
                                <div class="tips">
                                  <span class="noCommon" v-if="label.commonUse" @click="setCommonUse(label,0)">
                                    <img src="@/assets/images/取消常用.png" alt="">
                                    取消常用
                                  </span>
                                  <span class="common" style="color: #666666;" v-else @click="setCommonUse(label,1)">
                                    <img src="@/assets/images/设为常用.png" alt="">
                                    设为常用
                                  </span>
                                </div>
                              </el-popover>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <el-popover
                                placement="right"
                                width="100"
                                trigger="hover"
                                popper-class="popoverSet"
                                :close-delay="1"
                                :open-delay="350"
                                ref="popoverRef"
                              >
                              <div slot="reference">
                                <span class="icon-dot" v-if="label.isNew"></span>
                                {{ label.labelMeaning }}
                              </div>
                              <div class="tips">
                                <span class="noCommon" v-if="label.commonUse" @click="setCommonUse(label,0)">
                                  <img src="@/assets/images/取消常用.png" alt="">
                                  取消常用
                                </span>
                                <span class="common" style="color: #666666;" v-else @click="setCommonUse(label,1)">
                                  <img src="@/assets/images/设为常用.png" alt="">
                                  设为常用
                                </span>
                              </div>
                            </el-popover>
                          </template>
                          <img alt src="@/assets/images/gou.png" />
                        </div>
                      </div>
                    </span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右测详情内容 -->
        <div class="attr-rightbigbox">
          <div class="tip-line" style="margin-bottom: 25px">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 0 4px 0 3px;
              "
            />
            <span>多个标签之间是交集的关系，如需更灵活的人群交并差，可在客户分群-人群运算或者精准营销功能中进行</span>
            <!-- <span style="color: #FE4D45">需要满足</span>
            <span>以下标签;标签之间取交集即为所选人群</span> -->
          </div>
          <div class="attr-right">
            <div style="text-align: center; margin-top: 80px" v-if="defaultShow == true">
              <img src="@/assets/images/default/暂无任何商品.png" />
              <br />
              <span style="color: #999">请从左侧选取标签在此编辑</span>
            </div>
            <div v-for="(item, index) in dataList" :key="item.firstLevelCategory + index">
              <div class="first-title" style="position:relative" v-show="item.isShow">
                {{ item.firstLevelCategory }}
                <div class="content slider" v-if="item.firstLevelCategory == '品类标签'">
                  <el-button
                    style="width: 120px;
                    position: absolute;
                    top: -7px;
                    left: 75px;"
                    @click="Category(index)"
                    >选择类目（{{ goodsClass.length }}）</el-button
                  >
                </div>
                <div class="content slider" v-if="item.firstLevelCategory == '品牌标签'">
                  <el-button
                    style="width: 120px;
                    position: absolute;
                    top: -7px;
                    left: 75px;"
                    @click="BrandCategory(index)"
                    >选择品牌（{{ brandsList.length }}）</el-button
                  >
                </div>
                <div v-if="item.firstLevelCategory == '互动标签'"
                  style="margin: 10px 14px;
                  font-size: 12px;
                  color: #fe4d45;
                ">
                  注意：互动标签仅支持同步参与【京获客】互动且已开卡的人群，如需同步所有互动用户建议创建活动时设置仅限会员参与。
                </div>
              </div>
              
              <div v-for="(labelItem, labelIndex) in item.data" :key="labelIndex">
                <!-- <div class="module-title">{{labelItem.secondLevelCategory}}</div> -->
                <div class="attr-content-item" v-for="(label, idx) in labelItem.data" :key="'label' + idx">
                  <template v-if="filterCategory(label.labelMeaning)">
                    <div v-if="label.valueData.visible">
                      <div class="title-line">
                        <span>{{ label.labelMeaning }}</span>
                        <div class="handle">
                          <el-popover placement="top-start" width="500" trigger="hover">
                            <button slot="reference" class="assistant">
                              运营助手
                            </button>
                            <div class="popoverWrap">
                              <div class="popoverItem">
                                <img src="@/assets/images/popover_label1.png" class="icon" />
                                <div class="desc">
                                  <span>标签定义</span>
                                  <span>{{ label.labelDefinition }}</span>
                                </div>
                              </div>
                              <div class="popoverItem">
                                <img src="@/assets/images/popover_label2.png" class="icon" />
                                <div class="desc">
                                  <span>运营建议</span>
                                  <span>{{ label.labelSuggestion }}</span>
                                </div>
                              </div>
                              <div class="popoverItem">
                                <img src="@/assets/images/popover_label3.png" class="icon" />
                                <div class="desc">
                                  <span>时间范围</span>
                                  <span>{{ label.labelSelectRange }}</span>
                                </div>
                              </div>
                            </div>
                          </el-popover>
                          <span class="delTxt" @click="delLabel(label, item, labelItem)">删除</span>
                        </div>
                      </div>
                      <!-- 类型0 单选 radio  -->
                      <div class="content radio-content" v-if="label.labelDisplayType == 0">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <!-- <el-radio-group v-model="radio"> -->
                        <el-radio
                          v-for="(checkItem, checkIndex) in label.enumValues"
                          v-model="label.valueData.value"
                          :key="checkIndex"
                          :label="checkItem.realValue"
                          >{{ checkItem.fieldValue }}</el-radio
                        >
                        <!-- </el-radio-group> -->
                      </div>
                      <!-- 类型10 生日-->
                      <div class="content time-range" v-if="label.labelDisplayType == 10">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <div style="margin-top: 14px" class="birth-input">
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.startMonth"
                            :maxlength="2"
                          ></el-input>
                          <span> 月 - </span>
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.startDay"
                            :maxlength="2"
                          ></el-input>
                          <span> 日 至 </span>
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.endMonth"
                            :maxlength="2"
                          ></el-input>
                          <span> 月 - </span>
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.endDay"
                            :maxlength="2"
                          ></el-input>
                          <span> 日</span>
                        </div>
                      </div>
                      <!-- 类型1 多选 checkbox -->
                      <div class="content radio-content" v-if="label.labelDisplayType == 1">
                        <!-- 其他类型按照原来逻辑，会员入会渠道走自定义弹窗逻辑 -->
                        <p class="labelExplain">
                          {{ label.labelExplain | labelExplain }}
                          <span style="color: red" v-if="label.labelExplain.indexOf('</span>') != -1">（注：workday工作日，restday休息日）</span>
                        </p>
                        <template v-if="label.labelExplain.indexOf('会员开卡的渠道') == -1">
                          <el-checkbox-group
                            @change="switchAllSelect(label)"
                            style="display: inline-block; margin-right: 20px;"
                            v-if="label.labelName == 'opdata_shop_member_channel'"
                            v-model="allSelectMembel"
                          >
                            <el-checkbox label="-1">全选</el-checkbox>
                          </el-checkbox-group>
                          <el-checkbox-group
                            :style="{
                              display: label.labelName == 'opdata_shop_member_channel' ? 'inline' : 'block',
                            }"
                            v-model="label.valueData.checkValue"
                            @change="switchAllSecletStatus(label)"
                          >
                            <el-checkbox v-for="(checkItem, checkIndex) in label.enumValues" :key="checkIndex" :label="checkItem.realValue">{{
                              checkItem.fieldValue
                            }}</el-checkbox>
                          </el-checkbox-group>
                        </template>
                        <template v-else>
                          <div style="margin: 12px 0;">
                            <span class="select-qd">选择开卡渠道</span>
                            <el-button type="danger" plain @click="openQdDialog(checkedCustomId, label.valueData.checkValue, label, InteractionID)">已选择{{ checkedCustomId.length + checkOfficialIdList.length + InteractionID.length }}个</el-button>
                          </div>
                          <el-dialog title="选择渠道" :visible.sync="qdVisible" width="56%" :before-close="()=>{closeQdDialog(label)}">
                            <div class="tab-line">
                              <div class="tab-item" @click="handleSwitch(1)" :class="{ active: tabIndex == '1' }" :style="{
                                color: tabIndex == '1' ? globalBG : '',
                                'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
                              }">
                                官方渠道
                                <span></span>
                              </div>
                              <!-- 1.14迭代新增 -->
                              <div class="tab-item" @click="handleSwitch(5)" :class="{ active: tabIndex == '5' }" :style="{color: tabIndex == '5' ? globalBG : '','border-top': tabIndex == '5' ? '2px solid ' + globalBG : '',}">
                                互动渠道
                                <span></span>
                              </div>
                              <div class="tab-item" @click="handleSwitch(2)" :class="{ active: tabIndex == '2' }" :style="{
                                color: tabIndex == '2' ? globalBG : '',
                                'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
                              }">
                                手动录入渠道
                                <span></span>
                              </div>
                              <div class="tab-item" @click="handleSwitch(3)" :class="{ active: tabIndex == '3' }" :style="{
                                color: tabIndex == '3' ? globalBG : '',
                                'border-top': tabIndex == '3' ? '2px solid ' + globalBG : '',
                              }">
                                手动录入
                                <span></span>
                              </div>
                              <div class="tab-item" @click="handleSwitch(4)" :class="{ active: tabIndex == '4' }" :style="{
                                color: tabIndex == '4' ? globalBG : '',
                                'border-top': tabIndex == '4' ? '2px solid ' + globalBG : '',
                              }">
                                <!-- 1.14迭代 -->
                                已选（{{checkedCustomId.length + checkOfficialIdList.length + InteractionID.length }}个）
                                <span></span>
                              </div>
                            </div>
                            <div v-if="tabIndex == '1'">
                              <div class="title">以下为官方开卡渠道名称</div>
                              <div class="content-box" style="margin-top: -13px;">
                                <el-checkbox-group
                                  @change="switchAllOfficialSelect(label)"
                                  class="all-check"
                                  v-if="label.labelName == 'opdata_shop_member_channel'"
                                  v-model="allSelectMembel"
                                >
                                  <el-checkbox label="-1">全部</el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox-group
                                  class="flex-box-checkBox"
                                  v-model="label.valueData.checkValue"
                                  @change="switchAlloOfficialSecletStatus(label)"
                                >
                                  <el-checkbox v-for="(checkItem, checkIndex) in label.enumValues" :key="checkIndex" :label="checkItem.realValue">{{
                                    checkItem.fieldValue
                                  }}</el-checkbox>
                                </el-checkbox-group>
                              </div>
                            </div>
                            <div v-else-if="tabIndex == '2'" v-loading="loading1" style="position: relative;">
                              <div class="title">
                                <span>{{ mangeQd ? "以下为商家手动录入的开卡渠道ID" : "以下为商家手动录入的开卡渠道ID，删除渠道ID后，已创建的人群策略中如含该id不会自动剔除数据，需商家手动更改策略" }}</span>
                                <div class="manage-qd" @click="mangeQd = !mangeQd">
                                  <img :src="mangeQd ? require('@/assets/images/管理渠道.png') : require('@/assets/images/取消管理.png')" />
                                  <span>{{ mangeQd ? "管理渠道" : "取消管理" }}</span>
                                </div>
                              </div>
                              <div class="content-box" style="margin-top: -13px;">
                                <template v-if="mangeQd">
                                  <el-checkbox-group
                                    @change="selectAllCustomId()"
                                    class="all-check"
                                    v-if="label.labelName == 'opdata_shop_member_channel'"
                                    v-model="allSelectCustomId"
                                  >
                                    <el-checkbox label="-1">全部</el-checkbox>
                                  </el-checkbox-group>
                                  <el-checkbox-group
                                    class="flex-box-checkBox"
                                    v-model="checkedCustomId"
                                    @change="switchAllCustomSecletStatus(label)"
                                  >
                                    <el-checkbox v-for="(checkItem, checkIndex) in customIdList" :key="checkIndex" :label="checkItem">{{
                                      checkItem
                                    }}</el-checkbox>
                                  </el-checkbox-group>
                                </template>
                                <template v-else>
                                  <el-checkbox-group
                                    @change="selectAllCustomId()"
                                    class="all-check"
                                    v-if="label.labelName == 'opdata_shop_member_channel'"
                                    v-model="allSelectCustomIdDel"
                                  >
                                    <el-checkbox label="-1">全部</el-checkbox>
                                  </el-checkbox-group>
                                  <el-checkbox-group
                                    class="flex-box-checkBox"
                                    v-model="batchDelId "
                                    @change="switchAllCustomSecletStatus(label)"
                                  >
                                    <el-checkbox v-for="(checkItem, checkIndex) in customIdList" :key="checkIndex" :label="checkItem">{{
                                      checkItem
                                    }}</el-checkbox>
                                  </el-checkbox-group>
                                </template>
                              </div>
                              <div class="custom-del" v-if="!mangeQd">
                                <el-button class="assistant" @click="delManualId">删除</el-button>
                              </div>
                            </div>
                            <div v-else-if="tabIndex == '3'" v-loading="loading" style="height:550px">
                              <div class="title">可手动录入渠道ID，支持一次录入多个渠道</div>
                              <div class="manual-input-box">
                                <el-input
                                  style="height: 136px;"
                                  type="textarea"
                                  placeholder="请输入"
                                  v-model.trim="manualId"
                                  @input="manualId = manualIdChange($event)"
                                >
                                </el-input>
                                <div class="manual-submit-btn" @click="addCustomQdId">确认录入</div>
                              </div>
                              
                              <div class="tips-box">
                                <img
                                  src="@/assets/images/new_icon_reminder1.png"
                                  class="tips-icon"
                                />
                                <div class="tips-content">
                                  <p>1、每行输入一个渠道ID；</p>
                                  <p>2、一次最多输入2000行；</p>
                                  <p>3、不可录入重复的渠道ID，如ID重复，则录入会自动剔除</p>
                                </div>
                              </div>
                            </div>

                          <!-- 1.14迭代需求 -->
                          <div v-else-if="tabIndex == '5'">
                            <div class="title">以下为【互动管理】下所有玩法的入会渠道</div>
                            <div class="content-box" style="margin-top: -13px;">
                              <el-checkbox-group @change="selectAllInteraction()" class="all-check"
                                v-if="label.labelName == 'opdata_shop_member_channel'" v-model="AllInteractionID">
                                <el-checkbox label="-1">全部</el-checkbox>
                              </el-checkbox-group>
                              <el-checkbox-group class="flex-box-checkBox" v-model="InteractionID"
                                @change="switchAllInteraction()">
                                <el-checkbox v-for="(itemInteraction,indexInteraction) in InteractionList" :key="indexInteraction"
                                  :label="itemInteraction.value" >{{ itemInteraction.label }}</el-checkbox>
                              </el-checkbox-group>
                            </div>
                          </div>

                            <div class="checked-box" v-else>
                              <div class="title-box">
                                <div>官方渠道（<span class="num">{{ checkOfficialIdList.length }}</span>个）</div>
                                <div class="clear" @click="clearCheckQdId(1, label)">
                                  <img src="@/assets/images/一键清空.png" alt="">
                                  <span>清空</span>
                                </div>
                              </div>
                              <div class="checked-content">
                                <div class="checked-item" v-for="(item, index) in checkOfficialIdList" :key="index">
                                  <span>{{ item.fieldValue }}</span>
                                  <img @click="delCheckQdId(index, 1, label)" src="@/assets/images/delete.png" alt="">
                                </div>
                              </div>
                              <div class="title-box">
                                <div>手动录入渠道（<span class="num">{{ checkedCustomId.length }}</span>个）</div>
                                <div class="clear" @click="clearCheckQdId(0)">
                                  <img src="@/assets/images/一键清空.png" alt="">
                                  <span>清空</span>
                                </div>
                              </div>
                              <div class="checked-content">
                                <div class="checked-item" v-for="(item, index) in checkedCustomId" :key="index">
                                  <span>{{ item }}</span>
                                  <img @click="delCheckQdId(index, 0)" src="@/assets/images/delete.png" alt="">
                                </div>
                              </div>
                            <!-- 1.14迭代需求 -->
                            <div class="title-box">
                              <div>互动渠道（<span class="num">{{ InteractionID.length }}</span>个）</div>
                              <div class="clear" @click="clearCheckQdId(2)">
                                <img src="@/assets/images/一键清空.png" alt="">
                                <span>清空</span>
                              </div>
                            </div>
                            <div class="checked-content">
                              <div class="checked-item" v-for="(item, index) in InteractionID" :key="index">
                                <span>{{ InteractionFindLable(item) }}</span>
                                <img @click="delCheckQdId(index, 2)" src="@/assets/images/delete.png" alt="">
                              </div>
                            </div>
                            
                            </div>
                            <div style="text-align:right" class="btn-group">
                              <el-button @click="closeQdDialog(label)">取消</el-button>
                              <el-button @click="selectQdId" type="primary">确认</el-button>
                            </div>
                          </el-dialog>
                        </template>
                      </div>
                      <!-- 类型3 区间范围选择器 -->
                      <div class="content area-select" v-if="label.labelDisplayType == 3">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <div style="margin-top: 14px">
                          <el-select @change="rangeTypeChange(label)" v-model="label.valueData.rangeType">
                            <el-option v-for="(item, index) in areaSelect" :key="index" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                          <!-- v-only-number -->
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            v-if="label.valueData.rangeType != -1"
                            placeholder="起"
                            v-model="label.valueData.minValue"
                          ></el-input>
                          <span v-if="label.valueData.rangeType == 0" class="to-text">至</span>
                          <!-- v-only-number -->
                          <el-input
                            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                            v-if="label.valueData.rangeType != 1"
                            placeholder="至"
                            v-model="label.valueData.maxValue"
                          ></el-input>
                        </div>
                      </div>
                      <!-- 类型7 选择省市 -->
                      <div class="content select-city-box" v-if="label.labelDisplayType == 7">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <el-button style="margin-top: 14px" @click="handleSelectCity(index, labelIndex, idx)"
                          >选择省市（{{ provinces && provinces.length }}）</el-button
                        >
                      </div>
                      <!-- 类型5 指定商品 指定sku -->
                      <div class="content goods-sku-box" v-if="label.labelDisplayType == 5">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <!-- <el-radio-group v-model="labels"> -->
                        <el-radio :label="0" v-model="label.valueData.skuType">
                          <span>指定商品</span>
                          <el-button
                            style="margin-top: 14px"
                            @click="showSelectGoods(index, labelIndex, idx)"
                            :disabled="label.valueData.skuType != 0"
                            :style="{
                              color: label.valueData.skuType == 0 ? globalBG : '#C0C4CC',
                              'border-color': label.valueData.skuType == 0 ? globalBG : '#EBEEF5',
                            }"
                            >选择商品（{{ label.valueData.goodsList.length }}）</el-button
                          >
                        </el-radio>
                        <el-radio :label="1" v-model="label.valueData.skuType">
                          <span>指定sku</span>
                          <el-input
                            type="text"
                            v-model.trim="label.valueData.value"
                            @input="limitSkuId(index, labelIndex, idx)"
                            placeholder="多个sku请用英文逗号隔开"
                          ></el-input>
                        </el-radio>
                        <!-- </el-radio-group> -->
                      </div>
                      <!-- 类型2 滑块组件 取值 -->
                      <div class="content slider" v-if="label.labelDisplayType == 2">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <el-slider v-model="label.valueData.slideValue" show-input></el-slider>
                      </div>
                      <!-- 类型6  商品类目-->
                      <div class="content slider" v-if="label.labelDisplayType == 6">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <el-button style="margin-top: 14px; width: 120px" @click="showCategoryDialog(index, labelIndex, idx, label.valueData.value)"
                          >选择类目（{{ label.valueData.value.length }}）</el-button
                        >
                      </div>
                      <!-- 类型4 时间范围选择器 -->
                      <div class="content time-range" v-show="label.labelDisplayType == 4">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <div style="margin-top: 14px">
                          <el-select @change="timeTypeChange(label)" v-model="label.valueData.rangeType" style="width: 100px; margin-right: 20px">
                            <template v-if="label.labelName == 'opdata_shop_ord_date' || label.labelName == 'opdata_shop_presale_last1year_time' || label.labelName == 'opdata_shop_giftcard_rechargedates'">
                              <el-option v-for="(item, index) in areaSelectTime2" :key="index" :label="item.label" :value="item.value"></el-option>
                            </template>
                            <el-option
                              v-else
                              v-for="(item, index) in areaSelectTime"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <!-- 区间时间 -->
                          <div class="my_select_time" v-if="label.valueData.rangeType == 0">
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="label.valueData.minTime"
                              type="date"
                              :placeholder="'选择日期时间'"
                              size="small"
                              format="yyyy-MM-dd"
                              @change="limitTimeRange(label)"
                              :picker-options="pickerOptionsList['pickerOptions' + label.labelName + 'start']"
                              value-format="yyyy-MM-dd"
                              style="width: 120px"
                              class="time1"
                              :clearable="false"
                            ></el-date-picker>
                            <div class="time_to_text">至</div>
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="label.valueData.maxTime"
                              @change="limitTimeRange(label)"
                              :picker-options="pickerOptionsList['pickerOptions' + label.labelName + 'end']"
                              type="date"
                              :placeholder="'选择日期时间'"
                              size="small"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              style="width: 135px"
                              class="time2"
                              :clearable="false"
                            ></el-date-picker>
                            <i class="el-icon-circle-close date_icon1" @click="clearTime(index, labelIndex, idx)"></i>
                            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                          </div>
                          <!-- 小于时间 -->
                          <el-date-picker
                            v-if="label.valueData.rangeType == 2"
                            prefix-icon="no_icon"
                            v-model="label.valueData.maxTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions(label)"
                            value-format="yyyy-MM-dd"
                            style="width: 240px"
                            :clearable="false"
                          ></el-date-picker>
                          <!-- 大于时间 -->
                          <el-date-picker
                            v-if="label.valueData.rangeType == 1"
                            prefix-icon="no_icon"
                            v-model="label.valueData.minTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions(label)"
                            value-format="yyyy-MM-dd"
                            style="width: 240px"
                            :clearable="false"
                          ></el-date-picker>
                          <!-- 日期 -->
                          <el-date-picker
                            v-if="label.valueData.rangeType == 4"
                            type="dates"
                            class="datePicker"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions(label)"
                            v-model="label.valueData.value"
                            placeholder="选择一个或多个日期"
                          >
                          </el-date-picker>
                          <!-- 相对时间 -->
                          <span v-if="label.valueData.rangeType == 3">
                            <el-input
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                              @blur="timeCheck(label,label.valueData.minTime,$event)"
                              placeholder="天"
                              v-model="label.valueData.minTime"
                              style="width: 125px"
                            ></el-input>
                            <span style="margin: 0 8px" class="to-text">至</span>
                            <el-input
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                              @blur="timeCheck(label,label.valueData.maxTime,$event)"
                              placeholder="天"
                              style="width: 125px"
                              v-model="label.valueData.maxTime"
                            ></el-input>
                          </span>
                        </div>
                      </div>
                      <!--类型8 直播输入框 -->
                      <div style="padding-left: 20px;" class="content slider" v-if="label.labelDisplayType == 8">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <el-input
                          style="width:280px;margin-top: 14px;"
                          v-model="label.valueData.value"
                          placeholder="请输入直播ID，多个id请用英文逗号隔开"
                        ></el-input>
                      </div>
                      <!-- 类型9 京获客活动双下拉框 -->
                      <div class="content time-range" v-if="label.labelDisplayType == 9">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <select-activity  :form.sync="label.valueData" :options="activityOptionsObj[label.labelName]" style="margin-top: 14px"></select-activity>
                      </div>
                      <!-- 互动标签 - 参与指定活动 -->
                      <div class="content time-range" v-if="label.labelName == 'hd_join_select'">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <div style="margin-top: 14px">
                          <span>参与时间：</span>
                          <el-select @change="timeTypeChange(label)" v-model="label.valueData.rangeType" style="width: 100px; margin-right: 20px">
                            <el-option label="不限"
                              value=""></el-option>
                            <el-option
                              v-for="(item, index) in areaSelectTime"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <!-- 区间时间 -->
                          <div class="my_select_time" v-if="label.valueData.rangeType === 0">
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="label.valueData.minTime"
                              type="date"
                              :placeholder="'选择日期时间'"
                              size="small"
                              format="yyyy-MM-dd"
                              :picker-options="pickerOptionsList['pickerOptions' + label.labelName + 'start']"
                              value-format="yyyy-MM-dd"
                              style="width: 120px"
                              class="time1"
                              :clearable="false"
                            ></el-date-picker>
                            <div class="time_to_text">至</div>
                            <el-date-picker
                              prefix-icon="no_icon"
                              v-model="label.valueData.maxTime"
                              :picker-options="pickerOptionsList['pickerOptions' + label.labelName + 'end']"
                              type="date"
                              :placeholder="'选择日期时间'"
                              size="small"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              style="width: 135px"
                              class="time2"
                              :clearable="false"
                            ></el-date-picker>
                            <i class="el-icon-circle-close date_icon1" @click="clearTime(index, labelIndex, idx)"></i>
                            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                          </div>
                          <!-- 小于时间 -->
                          <el-date-picker
                            v-if="label.valueData.rangeType == 2"
                            prefix-icon="no_icon"
                            v-model="label.valueData.maxTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions(label)"
                            value-format="yyyy-MM-dd"
                            style="width: 240px"
                            :clearable="false"
                          ></el-date-picker>
                          <!-- 大于时间 -->
                          <el-date-picker
                            v-if="label.valueData.rangeType == 1"
                            prefix-icon="no_icon"
                            v-model="label.valueData.minTime"
                            type="date"
                            :placeholder="'选择日期时间'"
                            size="small"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions(label)"
                            value-format="yyyy-MM-dd"
                            style="width: 240px"
                            :clearable="false"
                          ></el-date-picker>
                          <!-- 日期 -->
                          <el-date-picker
                            v-if="label.valueData.rangeType == 4"
                            type="dates"
                            class="datePicker"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions(label)"
                            v-model="label.valueData.value"
                            placeholder="选择一个或多个日期"
                          >
                          </el-date-picker>
                          <!-- 相对时间 -->
                          <span v-if="label.valueData.rangeType == 3">
                            <el-input
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                              placeholder="天"
                              v-model="label.valueData.minTime"
                              style="width: 125px"
                            ></el-input>
                            <span style="margin: 0 8px" class="to-text">至</span>
                            <el-input
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                              placeholder="天"
                              style="width: 125px"
                              v-model="label.valueData.maxTime"
                            ></el-input>
                          </span>
                        </div>
                        <div style="margin-top: 14px">
                          <span>指定活动：</span>
                          <select-activity :form.sync="label.valueData" :options="activityOptionsObj.hd_join_select" style="display:inline-block"></select-activity>
                        </div>
                        <div style="margin-top: 14px" class="area-select">
                          <span>参与次数：</span>
                          <el-select @change="joinRangeTypeChange(label)" v-model="label.valueData.joinRangeType">
                            <el-option v-for="(item, index) in areaSelect" :key="index" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                          <!-- v-only-number -->
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            v-if="label.valueData.joinRangeType != -1"
                            placeholder="起"
                            v-model="label.valueData.join_start_value"
                          ></el-input>
                          <span v-if="label.valueData.joinRangeType == 0" class="to-text">至</span>
                          <!-- v-only-number -->
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            v-if="label.valueData.joinRangeType != 1"
                            placeholder="至"
                            v-model="label.valueData.join_end_value"
                          ></el-input>
                        </div>
                        
                      </div>
                      <!-- 互动标签 - 生日时间 -->
                      <div class="content time-range" v-if="label.labelName == 'hd_birth_time'">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <div style="margin-top: 14px" class="birth-input">
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.startMonth"
                            :maxlength="2"
                          ></el-input>
                          <span> 月 - </span>
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.startDay"
                            :maxlength="2"
                          ></el-input>
                          <span> 日 至 </span>
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.endMonth"
                            :maxlength="2"
                          ></el-input>
                          <span> 月 - </span>
                          <el-input
                            oninput="value=value.replace(/\D/g,'')"
                            placeholder=""
                            v-model="label.valueData.endDay"
                            :maxlength="2"
                          ></el-input>
                          <span> 日</span>
                        </div>
                      </div>
                      <!-- 联合营销 单下拉框 -->
                      <div class="content select" v-if="label.labelDisplayType == 11">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <el-select v-model="label.valueData.activityId" style="margin-top:14px;">
                          <el-option v-for="sel,index in marketOptions[label.labelName]" :key="index" :label="sel.activityName" :value="sel.id"></el-option>
                        </el-select>
                      </div>
                      <!-- 互动活动参会列表 -->
                      <div class="content time-range" v-if="label.labelName == 'opdata_shop_interact_activitys'">
                        <p class="labelExplain">{{ label.labelExplain }}</p>
                        <select-activity-checks  :form.sync="label.valueData" :options="activityOptionsObj['hd_join_select']" style="margin-top: 14px"></select-activity-checks>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="footer-btn-box">
      <el-button class="computed-btn" @click="handlePeopleComputed" v-loading="compLoading">计算人群</el-button>
      <div class="text-label">
        当前已选择
        <span :style="{ color: globalBG }">{{ selectLabelCount }}</span
        >个标签，所选条件人群人数为 <span :style="{ color: globalBG }">{{ population }}</span
        >人
      </div>
      <el-button class="save-btn" @click="handleSave" :loading="shake">保存</el-button>
      <!-- <el-button class="cancel-btn" @click="handleCancel">取消</el-button> -->
    </div>
    <!-- 自定义城市弹窗 -->
    <city-popover v-model="cityShow" @on-change="getLocation" :checkedList="provinces"></city-popover>
    <!-- 商品类目 -->
    <goods-category-dialog @on-close="closeCategory" v-model="goodsCategoryDialog" :goodsClass="goodsClass"></goods-category-dialog>
    <!-- 品类标签 商品类目 -->
    <goods-category-dialog @on-close="handleCategory" :goodsSel="goodsSel" v-model="CategoryDialog" :goodsClass="goodsClass"></goods-category-dialog>
    <goods-pinlei-dialog @on-close="handleBrantCategory" v-model="pinpaiCategory" :brandsList="brandsList"></goods-pinlei-dialog>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsState"
      :isShow="goodsState"
      :selectGoods="returnSelectGoods"
      :skuSearch="venderType ? true : false"
      :selectGoodsSkuList="selectGoodsSkuList"
      :GoodsSkuIsflay="true"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods>
    <!-- 保存成功弹窗 -->
    <el-dialog :visible.sync="successDaiLog" title="提示" width="400px" append-to-body custom-class="send-con-dialog">
      <div class="success-tip">
        <img src="@/assets/images/tip_success.png" />
        <span>保存人群成功</span>
      </div>
      <div class="btn-group1">
        <el-button @click="continueCreate">继续创建</el-button>
        <el-button type="primary" @click="handleCancel(true);" style="padding-left:50px;">前往人群列表</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CityPopover from "@/views/manage/components/city-popover";
import SelectActivity from "@/components/select-activity";
import SelectActivityChecks from "@/components/select-activity-checks";
import goodsCategoryDialog from "./goods-category-dialog";
import goodsPinleiDialog from "./goods-pinlei-dialog";
import SelectGoods from "@/components/selectGoodsMonitor";
import { getLabel, compute, addCustomQdId, delCustomQdId, getCustomQdIdList,activityList } from "@/api/manage/memberLabelController";
import { addMemberCrowd, advancedTags, getLastUsed, getLastUsedCustom, lastUsedSave, lastUsedDelete } from "@/api/memberCrowd";
import {getTreeData,queryMemberCrowdDetail} from "@/api/manage/memberCrowdController";
import { getSeller } from "@/api/sellerController";

export default {
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
    // editData: {
    //   type: Object,
    // },
  },
  components: {
    CityPopover,
    goodsCategoryDialog,
    SelectGoods,
    goodsPinleiDialog,
    SelectActivity,
    SelectActivityChecks
  },
  filters: {
    labelExplain(value) {
      var result = value;
      if (value.indexOf("</span>") != -1) {
        // result = "根据客户近半年非大促期间的客户下单数据分析计算出偏好（注：workday工作日，restday休息日）";
        return result.split("<span")[0];
      }
      return result;
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.provinces = [];
        this.goodsClass = [];
        console.log('form',this.form);
        if (this.editData) {
          console.log(this.editData);
          this.form.name = this.editData.name;
          this.form.description = this.editData.description;
          this.form.precisionCrowdStrategyId = this.editData.precisionCrowdStrategyId;
          this.form.strategyId = this.editData.strategyId;
          this.form.type = this.editData.type || 1;
          this.getClassifyOptions(this.form.type,this.editData.classifyId);
          this.getHdOptions()
          // 拿到编辑条件
          const checkDataArr = JSON.parse(this.editData.strategy);
          console.log(checkDataArr);
          // 返回条件每一项的名字
          const tagnames = checkDataArr && checkDataArr.map((item) => item.tagname);
          // 遍历标签数组，对比每一项的名字是否相等
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                // 判断名字数组中是否存在当前item的名字
                if (tagnames.includes(item.labelName)) {
                  // 拿到当前item在编辑条件中的索引
                  const index = tagnames.indexOf(item.labelName);
                  console.log(tagnames, 5555555566);
                  dataItem.isShow = true;
                  item.valueData.visible = true;
                  this.selectLabelCount++;
                  if (dataItem.firstLevelCategory == "品类标签") {
                    if (item.labelMeaning == "一级品类") {
                      this.selectLabelCount--;
                      item.valueData.visible = false;
                    }
                    if (item.labelMeaning == "二级品类") {
                      this.selectLabelCount--;
                      item.valueData.visible = false;
                    }
                    if (item.labelMeaning == "三级品类") {
                      this.selectLabelCount--;
                      item.valueData.visible = false;
                    }
                    checkDataArr.forEach((ele) => {
                      if (ele.tagname == "item_first_cate_cd") {
                        this.goodsPerantID = ele.value[0];
                      }
                    });
                  }
                  if (dataItem.firstLevelCategory == "品牌标签") {
                    if (item.labelMeaning == "品牌id") {
                      this.selectLabelCount--;
                      item.valueData.visible = false;
                      this.brandsList = checkDataArr[index].value;
                    }
                  }
                  if (item.valueData.visible) {
                    this.pinleiCategory.push(dataItem.firstLevelCategory);
                  }

                  /**
                   * 内容回显
                   * labelDisplayType 对应的内容类型
                   * 0: 单选, 1: 多选, 2: 滑块取值, 3: 区间范围选择, 4: 时间范围选择, 5: 指定商品 指定sku, 6: 商品类目, 7: 选择省市,8:直播输入框
                   */
                  // console.log(item.labelDisplayType);
                  switch (item.labelDisplayType) {
                    case 0:
                      item.valueData.value = checkDataArr[index].value;
                      break;
                    case 10:
                      let start = checkDataArr[index].startValue;
                      let end = checkDataArr[index].endValue;
                      this.$set(item.valueData,'startMonth',start.substring(0,start.length-2));
                      this.$set(item.valueData,'startDay',start.substring(start.length-2));
                      this.$set(item.valueData,'endMonth',end.substring(0,end.length-2));
                      this.$set(item.valueData,'endDay',end.substring(end.length-2));
                      break;
                    case 11:
                      console.log(checkDataArr[index]);
                      item.valueData.activityId = checkDataArr[index].activityId
                      break;
                    case 1:
                      if (item.labelName == "opdata_shop_member_channel") {
                        // 会员入会渠道
                        var valueList = checkDataArr[index].checkValue || checkDataArr[index].value;

                        // 1.14迭代需求 这里回显
                        const actualArr3 = valueList.filter((dom) => {
                          return this.InteractionList.some(dom1 => dom1.value == dom)
                        })
                        this.InteractionID = actualArr3 // 手动录入渠道

                        if (valueList && valueList.length > 0) {
                          if (valueList.length == "74") {
                            this.allSelectMembel = ["-1"];
                          }
                          var delItem = [];
                          valueList.forEach((vItem, vIndex) => {
                            if (vItem == "2") {
                              valueList.push("2,3,995,998");
                              delItem = delItem.concat(["2", "3", "995", "998"]);
                            }
                            if (vItem == "212") {
                              valueList.push("212,213");
                              delItem = delItem.concat(["212", "213"]);
                            }
                            if (vItem == "420") {
                              valueList.push("420,666");
                              delItem = delItem.concat(["420", "666"]);
                            }
                            if (vItem == "1003") {
                              valueList.push("1003,1004,1234");
                              delItem = delItem.concat(["1003", "1004", "1234"]);
                            }
                            if (vItem == "4021") {
                              valueList.push("4021,4022,4023,402");
                              delItem = delItem.concat(["4021", "4022", "4023", "402"]);
                            }

                            if (vItem == "4031") {
                              valueList.push("4031,403");
                              delItem = delItem.concat(["4031", "403"]);
                            }

                            if (vItem == "4041") {
                              valueList.push("4041,4042,404");
                              delItem = delItem.concat(["4041", "4042", "404"]);
                            }
                          });
                          delItem.forEach((delItem, delIndex) => {
                            valueList.splice(this.arrayIndexOf(delItem, valueList), 1);
                          });
                          item.valueData.checkValue = valueList;
                          // 这里存在官方渠道id以及手动录入渠道id，需要过滤
                          const actualArr = item.enumValues.filter((dom) => {
                            return item.valueData.checkValue.some(dom1 =>dom1 == dom.realValue)
                          })
                          const actualArr1 = item.valueData.checkValue.filter((dom) => {
                            return this.customIdList.some(dom1 =>dom1 == dom)
                          })
                          const actualArr2 = item.valueData.checkValue.filter((dom) => {
                            return item.enumValues.some(dom1 =>dom1.realValue == dom)
                          })
                          
                          item.valueData.checkValue = actualArr2
                          this.checkOfficialIdList = actualArr // 官方渠道
                          this.checkedCustomId = actualArr1 // 手动录入渠道
                        }
                      } else {
                        item.valueData.checkValue = checkDataArr[index].checkValue || checkDataArr[index].value;
                      }

                      break;
                    case 2:
                      item.valueData.slideValue = checkDataArr[index].slideValue;
                      break;
                    case 3:
                      if (checkDataArr[index].startValue && checkDataArr[index].endValue) {
                        item.valueData.rangeType = 0;
                      } else if (checkDataArr[index].startValue) {
                        item.valueData.rangeType = 1;
                      } else {
                        item.valueData.rangeType = -1;
                      }
                      item.valueData.minValue = checkDataArr[index].startValue;
                      item.valueData.maxValue = checkDataArr[index].endValue;
                      break;
                    case 4:
                      item.valueData.minTime = checkDataArr[index].startValue;
                      item.valueData.maxTime = checkDataArr[index].endValue;
                      item.valueData.rangeType = +checkDataArr[index].timeSelectType;
                      if (checkDataArr[index].value && checkDataArr[index].value.length > 0) {
                        item.valueData.value = checkDataArr[index].value.split(",");
                      }
                      break;
                    case 5:
                      if ((checkDataArr[index].itemInfo && checkDataArr[index].itemInfo.length > 0)|| (checkDataArr[index].skuInfo && checkDataArr[index].skuInfo.length > 0)) {
                        item.valueData.skuType = 0;
                        item.valueData.goodsList = checkDataArr[index].value;
                        // 适应旧数据
                        if( !this.venderType && !checkDataArr[index].skuInfo){
                          item.valueData.itemInfo = checkDataArr[index].skuInfo;
                          item.valueData.skuInfo = checkDataArr[index].itemInfo;
                        }else{
                          item.valueData.itemInfo = checkDataArr[index].itemInfo;
                          item.valueData.skuInfo = checkDataArr[index].skuInfo;
                        }
                        
                
                      } else {
                        item.valueData.skuType = 1;
                        item.valueData.value = checkDataArr[index].value.join(",");
                      }
                      break;
                    case 6:
                      item.valueData.value = checkDataArr[index].value;
                      this.goodsClass = checkDataArr[index].value;
                      break;
                    case 7:
                      item.valueData.value = checkDataArr[index].value;
                      this.provinces = checkDataArr[index].value;
                      break;
                    case 8:
                      item.valueData.value = checkDataArr[index].value.join(",");
                      break;
                    case 9:
                      checkDataArr[index].activityType && (item.valueData.activityType = checkDataArr[index].activityType);
                      checkDataArr[index].activityId && (item.valueData.activityId = checkDataArr[index].activityId);
                      break;
                  }
                  // 互动标签 - 参与指定活动
                  if(item.labelName == 'hd_join_select'){
                    console.log('item.valueData.rangeType',item.labelName,item.valueData.rangeType)
                    item.valueData.rangeType = checkDataArr[index].timeSelectType === '' ? '' : +checkDataArr[index].timeSelectType;
                    item.valueData.minTime = checkDataArr[index].startValue;
                    item.valueData.maxTime = checkDataArr[index].endValue;
                    
                    checkDataArr[index].activityType && (item.valueData.activityType = checkDataArr[index].activityType);
                    checkDataArr[index].activityId && (item.valueData.activityId = checkDataArr[index].activityId);

                    if (checkDataArr[index].join_start_value && checkDataArr[index].join_end_value) {
                        item.valueData.joinRangeType = 0;
                      } else if (checkDataArr[index].join_start_value) {
                        item.valueData.joinRangeType = 1;
                      } else {
                        item.valueData.joinRangeType = -1;
                      }
                      item.valueData.join_start_value = checkDataArr[index].join_start_value;
                      item.valueData.join_end_value = checkDataArr[index].join_end_value;
                  }
                  // 互动活动参会列表
                  if(item.labelName == 'opdata_shop_interact_activitys'){
                    console.log('opdata_shop_interact_activitys',checkDataArr[index])
                    item.valueData.mode =  checkDataArr[index].mode
                    if(item.valueData.mode == "0"){
                      item.valueData.activityTypes = checkDataArr[index].activityTypes
                      item.valueData.interactActivityIds =  checkDataArr[index].interactActivityIds
                    }else{
                      item.valueData.activityId = checkDataArr[index].interactActivityIds.join(",")
                    }
                  }
                  
                  // 互动标签 - 生日时间
                  if(item.labelName == 'hd_birth_time'){
                    item.valueData.startMonth = checkDataArr[index].startMonth;
                    item.valueData.startDay = checkDataArr[index].startDay;
                    item.valueData.endMonth = checkDataArr[index].endMonth;
                    item.valueData.endDay = checkDataArr[index].endDay;
                  }
                  if (dataItem.firstLevelCategory == "品类标签") {
                    checkDataArr.forEach((ele) => {
                      if (ele.tagname == "item_first_cate_cd") {
                        this.goodsPerantID = ele.value[0];
                      }
                    });
                    if (tagnames.indexOf("item_first_cate_cd") != -1) {
                      this.goodpinpei = 1;
                    }
                    if (tagnames.indexOf("item_second_cate_cd") != -1) {
                      this.goodpinpei = 2;
                    }
                    if (tagnames.indexOf("item_third_cate_cd") != -1) {
                      this.goodpinpei = 3;
                    }
                    if (item.labelMeaning == "三级品类") {
                      this.goodsClass = item.valueData.value;
                      this.goodsItem = item.valueData.value;
                    }
                  }
                }
              });
            });
          });
        }else{
          this.getClassifyOptions();
        }
        //判断表格是否为空
        try {
          this.dataList.forEach((item) => {
            item.data.forEach((item1) => {
              item1.data.forEach((item2) => {
                if (item2.valueData.visible == true) {
                  throw new Error("End");
                } else {
                  this.defaultShow = true;
                }
              });
            });
          });
        } catch (e) {
          if (e.message === "End") {
            this.defaultShow = false;
          } else {
            this.defaultShow = true;
          }
        }
      }else{
        // this.handleWrap({firstLevelCategory:"常用标签"})
      }
    },
    shopInfo(newVal) {
      if (newVal) {
        console.log("this.shopInfo", this.shopInfo);
        this.shopMemberType = this.shopInfo.shopMemberType;
      }
    },
  },
  data() {
    return {
      visible: false,
      editData: {},
      shake : false, // 节流
      compLoading: false,
      isOrderHd: false, //京获客资格
      storageOfficialIdList: [], // 缓存已选的官方渠道Id列表
      storageOfficialId: [], // 缓存已选的官方渠道Id
      storageCustomId: [], // 缓存已选的手动录入渠道Id
      isCommonShow: true, // 常用标签显示状态
      loading: false,
      loading1: false,
      mangeQd: true, // 管理渠道
      batchDelId: [], // 批量删除id列表
      checkOfficialIdList: [], // 选中的官方渠道id
      checkedCustomId: [], // 已选自定义渠道id
      allSelectCustomId: [], // 自定义渠道id全选
      allSelectCustomIdDel: [], // 自定义渠道id全选-删除
      customIdList: ["全选"], // 自定义渠道id列表
      tabIndex: "1", // 渠道弹窗tab下标
      manualId: "", // 手动录入id
      qdVisible: false, // 选择渠道弹窗
      labels: 0,
      fasle: false,
      form: {
        name: "",
        description: "",
        type:1,
        classifyId:0,
      },

      dataList: [],
      isNewNum: 0,
      isSaveLocation: false,
      isShowNew: true,
      areaSelect: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: -1,
        },
      ],
      areaSelectTime: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "大于等于",
          value: 1,
        },
        {
          label: "小于等于",
          value: 2,
        },
        {
          label: "相对时间",
          value: 3,
        },
      ],
      areaSelectTime2: [
        {
          label: "区间",
          value: 0,
        },
        {
          label: "日期",
          value: 4,
        },
      ],
      areaSelectTime3: [
        {
          label: "日期",
          value: 4,
        },
      ],
      defaultShow: true, //无内容时跳出提示图标
      valueData: {
        minValue: "",
        maxValue: "",
        rangeType: 0, // 区间范围的值 0: 区间 1:大于 -1：小于
        slideValue: 0, // 滑动组件的值
        minTime: "",
        maxTime: "",
        itemInfo: [], // 商品信息
        skuInfo:[],
        skuType: 0, // 0. 指定商品 1.指定sku
        checkValue: [], // sku的值
        value: "",
        visible: false,
        goodsList: [],
      },
      allSelectMembel: [], // 会员入会渠道标签全选
      cityShow: false,
      provinces: [],
      goodsClass: [], //商品类目
      goodsCategoryDialog: false,
      searchStatus: false, // 是否为查询状态
      searchValue: "", // 查询值
      goodsState: false,
      returnSelectGoods: [],
      selectGoodsSkuList:[],
      currentIndex: [], // 第一个值表示dataIndex, 第二个值表示labelIndex
      pickerOptionsList: {},
      inputWidth: 200,
      valLength: 0,
      pickerOptions: function(obj) {
        let timeRange = obj.labelSelectRange
        let stamp = 0
        let dataRange = new Date()
        if(timeRange == "近90天") stamp = 91
        if(timeRange == "近400天") stamp = 401
        if(timeRange == "近三年") stamp = 1096
        if(timeRange == "近1月") stamp = 31
        if(timeRange == "近1年" || timeRange == "近一年") stamp = 366
        if(timeRange == "近2年" || timeRange == "近两年") stamp = 731
        if(timeRange == "历史所有") stamp = 0
        if(stamp){
          dataRange.setDate(dataRange.getDate() - stamp);
          dataRange = dataRange.getTime()
        }
        return {
          disabledDate: (time) => {
            if(stamp){
              return time.getTime() > Date.now() || time.getTime() < dataRange;
            }else{
              return time.getTime() > Date.now();
            }
          },
        }
      },
      // 选择标签数
      selectLabelCount: 0,
      // 计算人群数量
      population: 0,
      // 会员入会渠道标签的值
      memberChannel: [
        "1",
        "2,3,995,998",
        "101",
        "102",
        "103",
        "104",
        "105",
        "106",
        "113",
        "114",
        "115",
        "116",
        "117",
        "119",
        "120",
        "121",
        "130",
        "140",
        "150",
        "201",
        "202",
        "203",
        "212,213",
        "214",
        "215",
        "216",
        "217",
        "218",
        "219",
        "220",
        "301",
        "401",
        "405",
        "411",
        "420,666",
        "430",
        "501",
        "502",
        "503",
        "504",
        "601",
        "602",
        "603",
        "701",
        "801",
        "920",
        "999",
        "1003,1004,1234",
        "1301",
        "2011",
        "3021",
        "3022",
        "4021,4022,4023,402",
        "4031,403",
        "4032",
        "4033",
        "4034",
        "4035",
        "4036",
        "4037",
        "4041,4042,404",
      ],
      allMemberChannel: [
        "1",
        "2",
        "3",
        "995",
        "998",
        "101",
        "102",
        "103",
        "104",
        "105",
        "106",
        "113",
        "114",
        "115",
        "116",
        "117",
        "119",
        "120",
        "121",
        "130",
        "140",
        "150",
        "201",
        "202",
        "203",
        "212",
        "213",
        "214",
        "215",
        "216",
        "217",
        "218",
        "219",
        "220",
        "301",
        "401",
        "405",
        "411",
        "420",
        "666",
        "430",
        "501",
        "502",
        "503",
        "504",
        "601",
        "602",
        "603",
        "701",
        "801",
        "920",
        "999",
        "1003",
        "1004",
        "1234",
        "1301",
        "2011",
        "3021",
        "3022",
        "4021",
        "4022",
        "4023",
        "402",
        "4031",
        "403",
        "4032",
        "4033",
        "4034",
        "4035",
        "4036",
        "4037",
        "4041",
        "4042",
        "404",
      ],
      shopMemberType: "",
      // 获取隐藏标签列表
      permissionsList: [],
      // shangpingleimu
      CategoryDialog: false, // 弹框
      goodsIndex: 0, // 品类 下标
      goodsPerantID: -111, // 品类  一类的父ID
      goodpinpei: 0, // 判断商品类目选择第几大类
      pinleiCategory: [], //判断品类和其他类 二选一
      goodsSel: false, // 判断为店铺还是商品名称
      goodsItem: [],
      //品牌
      pinpaiCategory: false,
      brandsList: [],
      brandIndex: 0,
      advanced: ["", ""],
      leftWarpTitle: "常用标签", // 左侧查询条件
      flag1:false, // 节流状态
      throttletimer:null, // 节流定时器
      recentlyList:[], // 最近使用列表
      commonUseList: [], // 自定义设置列表
      successDaiLog: false, // 保存成功弹窗
      popoverStatus: true,
      // 选择分类
      customClassifyOptions: [], // 自定义人群分类
      hdClassifyOptions: [], // 互动人群分类
      classifyData: null,
      // 互动
      activityOptionsObj:{
        hd_join_select:[ // 参与指定活动
          { label:"签到赢好礼",value:	1},
          { label:"每日限时抢",value:	3},
          { label:"关注店铺有礼",value:	4},
          { label:"完善信息有礼",value:	7},
          { label:"加购有礼",value:	34},
          { label:"开卡礼包",value:	13},
          { label:"店铺礼包",value:	14},
          { label:"店铺礼包（千人千面）",value:	15},
          { label:"预售有礼",value:	27},
          { label:"预售抽奖",value:	28},
          { label:"首购有礼",value:	17},
          { label:"复购有礼",value:	18},
          { label:"下单有礼",value:	16},
          { label:"下单抽奖",value:	19},
          { label:"评价有礼",value:	20},
          { label:"邀请开卡有礼",value:	5},
          { label:"邀请关注有礼",value:	6},
          { label:"裂变神券",value:	21},
          { label:"超级裂变券",value:	31},
          { label:"大转盘抽奖",value:	8},
          { label:"天降红包雨",value:	22},
          { label:"欢乐娃娃机",value:	23},
          { label:"大家来找茬",value:	24},
          { label:"刮刮乐",value:	26},
          { label:"0元试用",value:	33},
          { label:"积分兑换优惠券",value:	10},
          { label:"积分兑换实物",value:	9},
          { label:"积分兑换京豆",value:	29},
          { label:"积分兑换E卡",value:	30},
        ],
        hd_open_card:[ // 互动开卡
          { label:"签到赢好礼",value:	1},
          { label:"每日限时抢",value:	3},
          { label:"关注店铺有礼",value:	4},
          { label:"完善信息有礼",value:	7},
          { label:"加购有礼",value:	34},
          { label:"预售有礼",value:	27},
          { label:"预售抽奖",value:	28},
          { label:"首购有礼",value:	17},
          { label:"复购有礼",value:	18},
          { label:"下单有礼",value:	16},
          { label:"下单抽奖",value:	19},
          { label:"评价有礼",value:	20},
          { label:"邀请开卡有礼",value:	5},

          { label:"裂变神券",value:	21},

          { label:"大转盘抽奖",value:	8},
          { label:"天降红包雨",value:	22},
          { label:"欢乐娃娃机",value:	23},
          { label:"大家来找茬",value:	24},
          { label:"刮刮乐",value:	26},
          { label:"0元试用",value:	33},
          { label:"积分兑换优惠券",value:	10},
          { label:"积分兑换实物",value:	9},
          { label:"积分兑换京豆",value:	29},
          { label:"积分兑换E卡",value:	30},
        ],
        hd_introducing_pay:[ //互动引入付款
          {label: "预售抽奖", value: 28},
          {label: "预售有礼", value: 27},
          {label: "首购有礼", value: 17},
          {label: "复购有礼", value: 18},
          {label: "下单有礼", value: 16},
          {label: "下单抽奖", value: 19},
        ], 
        hd_introducing_trade:[ //互动引入交易
          {label: "预售抽奖", value: 28},
          {label: "预售有礼", value: 27},
          {label: "首购有礼", value: 17},
          {label: "复购有礼", value: 18},
          {label: "下单有礼", value: 16},
          {label: "下单抽奖", value: 19},
        ], 
        hd_split_user:[  //裂变用户
          {label: "邀请开卡有礼", value: 5},
          {label: "邀请关注有礼", value: 6},
          {label: "裂变神券", value: 21},
          {label: "超级裂变券", value: 31},
        ],
      },
      // 联合营销下拉
      marketOptions:{
        // 开卡
        uinte_open_card:[],
        // 领券
        unite_get_coupon:[],
      },

      //1.14迭代需求
      InteractionList:[{label:'全选',value:'全选'}], //互动渠道列表
      AllInteractionID:[], //互动渠道全选
      InteractionID:[], //互动渠道勾选
      storageInteraction:[], //缓存互动渠道
      InteractionSelect: [
        { label: "日历签到", value: "80140858" },
        { label: "关注店铺有礼", value: "80140859" },
        { label: "首单专享礼", value: "80140860" },
        { label: "下单有礼", value: "80140861" },
        { label: "下单抽奖", value: "80140862" },
        { label: "复购有礼", value: "80140863" },
        { label: "加购有礼", value: "80140864" },
        { label: "下单冲榜", value: "80140865" },
        { label: "预售有礼", value: "80140866" },
        { label: "预售抽奖", value: "80140867" },
        { label: "大转盘抽奖", value: "80140868" },
        { label: "完善信息有礼", value: "80140869" },
        { label: "评价有礼", value: "80140870" },
        { label: "每日限时抢", value: "80140871" },
        { label: "天降红包雨", value: "80140872" },
        { label: "欢乐娃娃机", value: "80140873" },
        { label: "大家来找茬", value: "80140874" },
        { label: "邀请开卡有礼", value: "80140875" },
        { label: "邀请关注有礼", value: "80140876" },
        { label: "裂变神券", value: "80140877" },
        { label: "超级裂变券", value: "80140878" },
        { label: "生日有礼", value: "80143365" },
        { label: "积分兑换实物", value: "80140879" },
        { label: "积分兑换优惠券", value: "80140880" },
        { label: "积分兑换京豆", value: "80140881" },
        { label: "积分兑换E卡", value: "80140882" },
        { label: "积分兑换红包", value: "80141719" },
        { label: "开卡礼包", value: "80140883" },
        { label: "店铺礼包", value: "80140884" },
        { label: "店铺礼包（千人千面）", value: "80140885" },
        { label: "0元试用", value: "80140886" },
        { label: "会员卡片", value: "80140887" },
        { label: "刮刮乐", value: "80140888" },
        { label: "智能活动海报", value: "80140889" },
        { label: "白条免息活动", value: "80140890" },
      ]
    };
  },
  async created() {
    // 1.14迭代需求
    this.getInteractionChannel()

    const {id,type} = this.$route.query
    if(id){
      const {data} = await queryMemberCrowdDetail({precisionCrowdStrategyId:id})
      // 复制
      if(type == 2){
        data.precisionCrowdStrategyId = "";
        data.strategyId = "";
        data.name = data.name + "副本";
        if (data.name.length > 60) {
          data.name = data.name.substr(0, 60);
        }
      }
      this.editData = data
    }
    this.permissionsList = this.$store.getters.loginUserInfo.permissions;

    this.getLabelList();
    this.getCustomQdIdList();
    advancedTags().then((res) => {
      this.advanced = res.data;
    });
    this.getHdOptions()
  },

  mounted() {
    var dotDays = localStorage.getItem("dotDays");
    var nowDays = new Date().getDate();
    this.isShowNew = dotDays != nowDays;
    // 监听中间标签盒子的滚动
    let scrollEle = document.getElementById('scrollEle')
    scrollEle.addEventListener("scroll",this.handleScroll)
    getSeller().then(res => {
      if (res.code == 1) {
        this.isOrderHd = res.data.isOrderHd;
      } else {
        this.$message.warning(res.message);
      }
    });
  },
  beforeDestroy(){
    // 卸载监听
    let scrollEle = document.getElementById('scrollEle')
    scrollEle.removeEventListener("scroll",this.handleScroll)
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
    // 是否无标签数据
    isNoData(){
      let flag = true
      this.dataList.forEach( item =>{
        // 有搜索结果，flag改为false
        if(item.searchWrap) flag = false;
      })
      return flag
    },
    venderType(){
      return this.$store.getters.loginUserInfo.venderType
    },
    // 根据会员标签隐藏某些属性
    hideLabelByMemberType(){
      return (label)=>{
        if (this.shopMemberType == "2" || this.shopMemberType == "4") {
          // 隐藏 品牌会员、品牌会员等级、用户品牌积分余额、品牌会员开卡时间
          if (
            label.labelName == "opdata_shop_brand_member_flag" ||
            label.labelName == "opdata_shop_brand_member_level" ||
            label.labelName == "opdata_brand_points" ||
            label.labelName == "opdata_shop_brand_bindingcard_tm"
          ) {
            return true
          }
        } else if (this.shopMemberType == "3" || this.shopMemberType == "5") {
          // 隐藏 店铺开卡会员、店铺会员等级、店铺积分余额、店铺会员开卡时间
          if (
            label.labelName == "opdata_shop_card_member_flag" ||
            label.labelName == "opdata_shop_member_level" ||
            label.labelName == "opdata_shop_points" ||
            label.labelName == "opdata_shop_bindingcard_tm"
          ) {
            return true
          }
        }else{
          return false
        }
      }
    }
    // 常用标签显示隐藏
    // isCommonShow(){
    //   let flag = false
    //   this.recentlyList.forEach(item=>{
    //     if(item.searchItem) flag = true;
    //   })
    //   this.commonUseList.forEach(item=>{
    //     if(item.searchItem) flag = true;
    //   })
    //   return flag
    // },
    // 自定义设置显示隐藏
    // customShow(){
    //   let flag = false
    //   this.commonUseList.forEach(item=>{
    //     if(item.searchItem) flag = true;
    //   })
    //   return flag
    // },
    // // 最近常用显示隐藏
    // recentlyShow(){
    //   let flag = false
    //   this.recentlyList.forEach(item=>{
    //     if(item.searchItem) flag = true;
    //   })
    //   return flag
    // }
  },
  methods: {
    // 1.14迭代需求
    InteractionFindLable(value){
      let res = ''
      this.InteractionSelect.forEach(item=>{
        if(item.value==value){
          res = item.label
        }
      })
      return res
    },
    // 获取互动渠道接口
    getInteractionChannel() {
      this.InteractionList = [{label:'全选',value:'全选'}, ...this.InteractionSelect]
    },
    // 全选互动渠道
    selectAllInteraction(){
      if (this.AllInteractionID.length == "1" && this.AllInteractionID[0] == "-1") {
        console.log('全选')
        // 全选
        this.InteractionList.slice(1, this.InteractionList.length).forEach(item=>{
          this.InteractionID.push(item.value)
        })
      } else {
        // 全不选
        this.InteractionID = [];
      }
    },
    // 勾选互动渠道
    switchAllInteraction(){
      if (this.InteractionList.length - 1 === this.InteractionID.length) {
          this.AllInteractionID = ["-1"];
        } else {
          this.AllInteractionID = [];
        }
    },

    isNewImg(str){
      let arr = ["数量相关标签","店铺加购标签","其他偏好标签"]
      if(arr.indexOf(str) != -1){
        return true
      }else {
        return false
      }
    },
    timeCheck(label,value,e){
      let timeRange = label.labelSelectRange
      if(timeRange == "近90天"){
        if(value > 90) {
          this.$message.error("时间范围不能超过90天")
          e.target.value = ""
        }
      }
      if(timeRange == "近三年"){
        if(value > 1095) {
          this.$message.error("时间范围不能超过三年")
          e.target.value = ""
        }
      }
      if(timeRange == "近1月"){
        if(value > 30) {
          this.$message.error("时间范围不能超过1个月")
          e.target.value = ""
        }
      }
      if(timeRange == "近2年"){
        if(value > 730) {
          this.$message.error("时间范围不能超过2年")
          e.target.value = ""
        }
      }
    },
    // 获取互动相关选项
    getHdOptions(){
      let def = {
        activityName: "不限",
        id: ""
      }
      console.log(23);
      activityList({isGetCoupon:true}).then(res=>{
        this.marketOptions.unite_get_coupon = [def,...res.data] || [def]
      })
      activityList({isGetCoupon:false}).then(res=>{
        this.marketOptions.uinte_open_card = [def,...res.data] || [def]
      })
    },
    // 手动录入文本框限制
    manualIdChange(value) {
      let str = String(value.replace(/[^\d\n]/g,''))
      const arr = str.split("\n")
      if(arr.length > 2000) {
        this.$message.warning("一次最多输入2000行")
        const otherArr = arr.slice(0, 2000)
        str = otherArr.join("\n")
        return str
      }
      return value.replace(/[^\d\n]/g,'')
    },
    // 获取人群分类二级选项
    getClassifyOptions(type=1,classifyId=0) {
      getTreeData().then(res => {
        let data = res.data[0].children
        console.log(data);
        data.forEach(item => {
          if(item.type == 1){
            this.customClassifyOptions = item.children
          }
        })
        this.form.classifyId = classifyId;
      })
      // queryCrowdClassify(1).then(res=>{
      //   if(res.code == 1){
      //     this.customClassifyOptions = res.data;
      //     if(type == 1){
      //       this.form.classifyId = classifyId;
      //     }
      //   }else{
      //     this.$message.error(res.message);
      //   }
      // })
      // queryCrowdClassify(13).then(res=>{
      //   if(res.code == 1){
      //     this.hdClassifyOptions = res.data;
      //     if(type == 13){
      //       this.form.classifyId = classifyId;
      //     }
      //   }else{
      //     this.$message.error(res.message);
      //   }
      // })
    },
    // 选择分类切换
    handleChangeType(val){
      console.log(val);
      if(this.pinleiCategory.length){
        if(this.pinleiCategory.includes("互动标签") && val ==1){
          this.form.type = 13;
          this.$message.warning("所选分类与标签不一致，请重新选择");
        }else if(!this.pinleiCategory.includes("互动标签") && val ==13){
          this.form.type = 1;
          this.$message.warning("所选分类与标签不一致，请重新选择");
        }else{
          this.form.classifyId = 0;
        }
      }else{
        this.form.classifyId = 0;
      }
    },

    delManualId() {
      // 二次确认删除
      if(this.batchDelId.length == 0) {
        this.$message.warning("你未勾选数据，请勾选后删除")
        return
      }
      this.$confirm(`已选择${this.batchDelId.length}条数据，是否确定删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading1 = true
        delCustomQdId(this.batchDelId).then(async (res) => {
          if(res.code == 1) {
            await this.getCustomQdIdList()
            this.checkedCustomId = this.checkedCustomId.filter((item) => {
              return !this.batchDelId.includes(item)
            })
            this.allSelectCustomIdDel = []
            this.batchDelId = []
            this.mangeQd = true
            this.loading1 = false
            this.$message.success("删除成功")
          }
        })
      }).catch(() => {      
      });
    },

    // 获取自定义渠道id
    getCustomQdIdList() {
      getCustomQdIdList().then((res) => {
        this.customIdList = ["全选", ...res.data]
      })
    },

    handleSwitch(index) {
      this.tabIndex = index
    },

    handleDialogSure() {

    },
    // 设为常用
    setCommonUse(item,type){
      // type: 0=>取消常用 1=>设为常用
      if(type){
        console.log("设为常用");
        if(this.commonUseList.length >= 10) return this.$message.warning("最多可自定义设置10个常用标签")
        lastUsedSave([item.labelName]).then(res=>{
          if(res.code == 1){
            this.getCommonUse(1)
          }
        })
      }else{
        console.log("取消常用");
        lastUsedDelete([item.id]).then(res=>{
          if(res.code == 1){
            this.getCommonUse(2)
          }
        })
      }
      console.log(item);
    },
    // 节流触发滚动，优化滚动时的卡顿
    handleScroll(){
      // console.log(this.$refs.popoverRef);
      this.$refs.popoverRef.forEach(item=>{
        item.doClose()
      })
      // 鼠标滚动后立即隐藏tooltip
      let list = document.getElementsByClassName('el-tooltip__popper')
      if (list.length > 0) {
        list[list.length - 1].style.display = 'none'
      }
      if(this.flag1) return
      this.flag1 = true
      this.throttletimer = setTimeout(() => {
        this.flag1 = false
        this.handleScrollFn()
      }, 400)
    },
    // 监听页面滚动
    handleScrollFn(){
      const navContents = document.querySelectorAll('.anchorPoint')
      let scrollEle = document.getElementById('scrollEle')
      // 监听元素滚动高度
      var currentScrollTop = scrollEle.scrollTop;
      let that = this;
      // 所有锚点元素的 offsetTop
      const offsetTopArr = []
      navContents.forEach(item => {
        let temp={
          offsetTop:item.offsetTop,
          id:item.id,
        }
        if(!item.offsetTop==0){
          offsetTopArr.push(temp)
        }
      })
      // 获取当前文档流的 scrollTop
      // 定义当前点亮的导航下标
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (currentScrollTop >= offsetTopArr[n].offsetTop - 200) {
          that.leftWarpTitle = offsetTopArr[n].id;
        }
        if(n == offsetTopArr.length-1){
          if (currentScrollTop >= offsetTopArr[n].offsetTop - 300) {
            that.leftWarpTitle = offsetTopArr[n].id;
          }
        }
      }
    },
    // 点击最左侧标签
    handleWrap(item) {
      // 左侧选择标签
      this.leftWarpTitle = item.firstLevelCategory;
      // 需要滑动的视窗
      let scrollEle = document.getElementById('scrollEle')
      scrollEle.removeEventListener("scroll",this.handleScroll)
      // 锚点标签
      let id = item.firstLevelCategory
      var el = document.getElementById(id);
      // 滚动到对应锚点位置
      this.$nextTick(function () {
        scrollEle.scrollTo({"behavior":"smooth","top":el&&el.offsetTop});
      })
      setTimeout(()=>{
        scrollEle.addEventListener("scroll",this.handleScroll)
      },1000)
    },
    // 隐藏直播标签等等
    filterCategory(val) {
      let hide = false;
      // if (val == "直播场景") {
      //   if (this.permissionsList.indexOf("hide:shop:live") != -1) {
      //     hide = false;
      //   } else {
      //     hide = true;
      //   }
      // }
      // if (val == "美妆行业直播标签") {
      //   if (this.permissionsList.indexOf("hide:live:makeup") != -1) {
      //     hide = false;
      //   } else {
      //     hide = true;
      //   }
      // }
      // if (val == "服饰行业标签") {
      //   if (this.permissionsList.indexOf("hide:clothes:tag") != -1) {
      //     hide = false;
      //   } else {
      //     hide = true;
      //   }
      // }
      // if (val == "品类标签") {
      //   if (this.permissionsList.indexOf("hide:cate:tag") != -1) {
      //     hide = false;
      //   } else {
      //     hide = true;
      //   }
      // }
      // if (val == "品牌标签") {
      //   if (this.permissionsList.indexOf("hide:brand:tag") != -1) {
      //     hide = false;
      //   } else {
      //     hide = true;
      //   }
      // }
      if (val == "一级品类") {
        hide = true;
      }
      if (val == "二级品类") {
        hide = true;
      }
      if (val == "三级品类") {
        hide = true;
      }
      if (val == "品牌id") {
        hide = true;
      }
      return hide != true;
    },
    switchAllSecletStatus(label) {
      if (label.valueData.checkValue.length === this.memberChannel.length) {
        this.allSelectMembel = ["-1"];
      } else {
        this.allSelectMembel = [];
      }
    },

    switchAlloOfficialSecletStatus(label) {
      this.checkOfficialIdList = label.enumValues.filter((item) => {
        return label.valueData.checkValue.includes(item.realValue)
      })
      if (label.valueData.checkValue.length === this.memberChannel.length) {
        this.allSelectMembel = ["-1"];
      } else {
        this.allSelectMembel = [];
      }
    },

    switchAllCustomSecletStatus() {
      if(this.mangeQd) {
        if (this.customIdList.length - 1 === this.checkedCustomId.length) {
          this.allSelectCustomId = ["-1"];
        } else {
          this.allSelectCustomId = [];
        }
      } else {
        if (this.customIdList.length - 1 === this.batchDelId.length) {
          this.allSelectCustomIdDel = ["-1"];
        } else {
          this.allSelectCustomIdDel = [];
        }
      }
    },

    // 全选自定义渠道id
    selectAllCustomId() {
      if (this.mangeQd) {
        if (this.allSelectCustomId.length == "1" && this.allSelectCustomId[0] == "-1") {
        // 全选
          this.checkedCustomId = this.customIdList.slice(1, this.customIdList.length);
        } else {
          // 全不选
          this.checkedCustomId = [];
        }
      } else {
        if (this.allSelectCustomIdDel.length == "1" && this.allSelectCustomIdDel[0] == "-1") {
        // 全选
          this.batchDelId = this.customIdList.slice(1, this.customIdList.length);
        } else {
          // 全不选
          this.batchDelId = [];
        }
      }
      
    },

    switchAllSelect(label) {
      if (this.allSelectMembel.length == "1" && this.allSelectMembel[0] == "-1") {
        // 全选
        label.valueData.checkValue = this.memberChannel;
      } else {
        // 全不选
        label.valueData.checkValue = [];
      }
    },

    // 会员入会官方渠道全选
    switchAllOfficialSelect(label) {
      if (this.allSelectMembel.length == "1" && this.allSelectMembel[0] == "-1") {
        // 全选
        label.valueData.checkValue = this.memberChannel;
        this.checkOfficialIdList = label.enumValues.slice(1, label.enumValues.length);
      } else {
        // 全不选
        label.valueData.checkValue = [];
        this.checkOfficialIdList = [];
      }
    },

    // 添加自定义渠道id
    async addCustomQdId() {
      let arr = this.manualId.split("\n")
      arr = [...new Set(arr)] // 数组去重
      const index = arr.indexOf("") // 删除空数据
      if(index != -1) {
        arr.splice(index, 1)
      }
      if (arr.length == 0) {
        this.$message.warning("你未输入渠道ID，请输入后录入")
        return
      }
      const newArr = arr.filter((item) => {
        return !this.allMemberChannel.includes(item)
      })
      
      this.loading = true
      const res = await addCustomQdId(newArr)
      if(res.code == 1) {
        this.$message.success("录入成功")
        await this.getCustomQdIdList()
        this.loading = false
      } else {
      }
    },

    // 删除已选的渠道id
    delCheckQdId(index, type, label = "") { // type: 1 (官方), type: 0 (自定义)
      if(type == 1) {
        const id = this.checkOfficialIdList[index].realValue
        this.checkOfficialIdList.splice(index, 1)
        const idx = label.valueData.checkValue.indexOf(id)
        label.valueData.checkValue.splice(idx, 1)
        if (label.valueData.checkValue.length === this.memberChannel.length) {
          this.allSelectMembel = ["-1"];
        } else {
          this.allSelectMembel = [];
        }
      } 
      if(type == 0) {
        this.checkedCustomId.splice(index, 1)
        this.switchAllCustomSecletStatus()
      }
      if(type == 2) {
        this.InteractionID.splice(index, 1)
        this.switchAllInteraction()
      }
    },

    // 清空已选的渠道id
    clearCheckQdId(type, label = "") { // type: 1 (官方), type: 0 (自定义)
      if(type == 1) {
        label.valueData.checkValue = []
        this.checkOfficialIdList = []
        this.allSelectMembel = []
      } 
      if(type == 0) {
        this.checkedCustomId = []
        this.allSelectCustomId = []
      }
      if(type == 2) {
        this.AllInteractionID = [] //互动渠道全选
        this.InteractionID = [] //互动渠道勾选
      }
    },  

    openQdDialog(data1,data2, item , data3) {
      // 1.14迭代需求 缓存data3：InteractionID 互动渠道 
      this.storageInteraction = JSON.parse(JSON.stringify(data3))

      const actualArr = item.enumValues.filter((dom) => {
        return item.valueData.checkValue.some(dom1 =>dom1 == dom.realValue)
      })
      this.storageCustomId = JSON.parse(JSON.stringify(data1))
      this.storageOfficialId = JSON.parse(JSON.stringify(data2))
      this.storageOfficialIdList = JSON.parse(JSON.stringify(actualArr))
      this.qdVisible = true
    },

    selectQdId() {
      this.loading = false
      this.qdVisible = false
      this.tabIndex = 1
      this.mangeQd = true
      this.batchDelId = []
      this.allSelectCustomIdDel = []
    },

    closeQdDialog(label) {
      label.valueData.checkValue = this.storageOfficialId
      this.checkOfficialIdList = this.storageOfficialIdList
      this.checkedCustomId = this.storageCustomId
      this.loading = false
      if (this.customIdList.length - 1 === this.checkedCustomId.length) {
        this.allSelectCustomId = ["-1"];
      } else {
        this.allSelectCustomId = [];
      }
      if (label.valueData.checkValue.length === this.memberChannel.length) {
        this.allSelectMembel = ["-1"];
      } else {
        this.allSelectMembel = [];
      }
      this.qdVisible = false
      this.tabIndex = 1
      this.mangeQd = true
      this.batchDelId = []
      this.allSelectCustomIdDel = []
    },
    
    rangeTypeChange(label) {
      label.valueData.minValue = "";
      label.valueData.maxValue = "";
    },
    joinRangeTypeChange(label) {
      label.valueData.join_start_value = "";
      label.valueData.join_end_value = "";
    },
    timeTypeChange(label) {
      label.valueData.maxTime = "";
      label.valueData.minTime = "";
    },
    // 获取标签
    getLabelList() {
      getLabel().then((res) => {
        let labelList = {};
        res &&
          res.data.forEach((key, index) => {
            let count = 0;
            key.searchWrap = true;
            key.isShow = false;

            key.data.forEach((item, index2) => {
              count += item.data.length;
              item.searchTitle = true;
              item.data.forEach((label, labelIndex) => {
                if (label.labelMeaning == "市") {
                  label.labelMeaning = "省市";
                }

                if (label.labelName == "opdata_base_profession") {
                  // 客户职业
                  var list1 = label.enumValues.filter((item) => {
                    return item.realValue !== "-1";
                  });
                  var list2 = label.enumValues.filter((item) => {
                    return item.realValue === "-1";
                  });
                  list1 = list1.sort((a, b) => {
                    return +a.realValue - +b.realValue;
                  });
                  label.enumValues = list1.concat(list2);
                }

                if (label.labelName == "opdata_shop_member_channel") {
                  //会员入会渠道
                  label.labelDisplayType = 1;
                  label.hasEnumValue = true;
                  label.labelParamEsType = "terms";
                  label.labelParamRule = "0";
                  label.enumValues = [
                    { realValue: "", fieldValue: "全选" },
                    { realValue: "1", fieldValue: "商详会员价" },
                    { realValue: "2,3,995,998", fieldValue: "测试渠道" }, // 2，3, 995,998
                    { realValue: "101", fieldValue: "卡包" },
                    { realValue: "102", fieldValue: "店铺首页" },
                    { realValue: "103", fieldValue: "app支付完成页" },
                    { realValue: "104", fieldValue: "App试用频道" },
                    { realValue: "105", fieldValue: "商详页" },
                    { realValue: "106", fieldValue: "积分兑换引导" },
                    { realValue: "113", fieldValue: "APP领券入会" },
                    { realValue: "114", fieldValue: "App品牌精选" },
                    { realValue: "115", fieldValue: "App导购码" },
                    { realValue: "116", fieldValue: "App门店码" },
                    { realValue: "117", fieldValue: "App品牌码" },
                    { realValue: "119", fieldValue: "APP Jpass支付完成页" },
                    { realValue: "120", fieldValue: "短信" },
                    { realValue: "121", fieldValue: "门店详情页" },
                    { realValue: "130", fieldValue: "APP-群聊(群内)" },
                    { realValue: "140", fieldValue: "APP-京东会员频道" },
                    { realValue: "150", fieldValue: "APP-客服咚咚" },
                    { realValue: "201", fieldValue: "开普勒" },
                    { realValue: "202", fieldValue: "Jzone" },
                    { realValue: "203", fieldValue: "小程序商详:会员价开卡楼层", },
                    { realValue: "212,213", fieldValue: "小程序领券入会" }, // 212,213
                    { realValue: "214", fieldValue: "小程序品牌精选" },
                    { realValue: "215", fieldValue: "小程序导购码" },
                    { realValue: "216", fieldValue: "小程序门店码" },
                    { realValue: "217", fieldValue: "小程序品牌码" },
                    { realValue: "218", fieldValue: "小程序支付完成页" },
                    { realValue: "219", fieldValue: "小程序卡包" },
                    { realValue: "220", fieldValue: "门店帮导购" },
                    { realValue: "301", fieldValue: "金融app" },
                    { realValue: "401", fieldValue: "H5页面" },
                    { realValue: "405", fieldValue: "m站商详:会员价开卡楼层" },
                    { realValue: "411", fieldValue: "快闪店" },
                    { realValue: "420,666", fieldValue: "联合开卡" },
                    { realValue: "430", fieldValue: "储值卡" },
                    { realValue: "501", fieldValue: "微q店铺首页" },
                    { realValue: "502", fieldValue: "微q商详" },
                    { realValue: "503", fieldValue: "微q结算页" },
                    { realValue: "504", fieldValue: "微q商详:会员价开卡楼层" },
                    { realValue: "601", fieldValue: "7-fresh" },
                    { realValue: "602", fieldValue: "溯源售后" },
                    { realValue: "603", fieldValue: "1元联合开卡" },
                    { realValue: "701", fieldValue: "商家自定义" },
                    { realValue: "801", fieldValue: "isv自定义" },
                    { realValue: "920", fieldValue: "通讯手机狂欢城" },
                    { realValue: "999", fieldValue: "默认渠道" },
                    { realValue: "1003,1004,1234", fieldValue: "分享" }, // 1003,1004,1234
                    { realValue: "1301", fieldValue: "APP-群聊(群入口)" },
                    { realValue: "2011", fieldValue: "开普勒-小程序拼券" },
                    { realValue: "3021", fieldValue: "h5砍价活动" },
                    { realValue: "3022", fieldValue: "小程序砍价活动" },
                    { realValue: "4021,4022,4023,402", fieldValue: "社交魔方" }, // 4021,4022,4023,402
                    { realValue: "4031,403", fieldValue: "大促活动" },
                    { realValue: "4032", fieldValue: "大促活动-互动会场" },
                    { realValue: "4033", fieldValue: "大促活动-预售会场" },
                    { realValue: "4034", fieldValue: "大促活动-狂欢城" },
                    { realValue: "4035", fieldValue: "大促活动-星店长" },
                    { realValue: "4036", fieldValue: "大促活动-20年618会员价会场", },
                    { realValue: "4037", fieldValue: "大促活动-20年618isv互动会场", },
                    { realValue: "4041,4042,404", fieldValue: "锦鲤抽奖" }, // 4041, 4042, 404
                  ];
                }

                label.valueData = {
                  minValue: "",
                  maxValue: "",
                  rangeType: label.labelName == 'hd_join_select' ? '' : 0, // 区间范围的值 0: 区间 1:大于 -1：小于
                  slideValue: 0, // 滑动组件的值
                  minTime: "",
                  maxTime: "",
                  itemInfo: [], // 商品信息
                  skuInfo:[],
                  skuType: 0, // 0. 指定商品 1.指定sku
                  checkValue: [], // sku的值
                  value: "",
                  visible: false,
                  goodsList: [],
                  activityType:"",
                  activityId:"",
                  // 互动标签-参与指定互动 参数 时间相关用4的参数，活动相关用9的参数
                  join_start_value:"",
                  join_end_value:"",
                  joinRangeType:0,
                  // 互动标签-生日时间 参数
                  startMonth:"",
                  startDay:"",
                  endMonth:"",
                  endDay:"",
                  // 互动活动参会列表
                  activityTypes: [""], // 活动类型
                  interactActivityIds: [""], // 活动ID
                  mode: "0", // 0指定活动 1指定活动id
                };

                label.searchItem = true;
                labelList[label.labelName] = {
                  name: label.labelMeaning,
                  enumValues: label.enumValues,
                  labelDisplayType: label.labelDisplayType,
                };
              });
            });
            key.labelCount = count;
          });
        this.dataList = res && res.data;
        // 设置标签属性
        if (this.dataList.length > 0) {
          this.dataList.forEach((key, index) => {
            key.data.forEach((item, index2) => {
              item.data.forEach((label, index3) => {
                if (!this.isShowNew) {
                  label.isNew = false;
                }
                if (label.labelDisplayType == 4) {
                  let obj = this.dataList[index].data[index2].data[index3];
                  this.limitTimeRange(obj);
                }
              });
            });
          });
        }
        this.visible = true
        // 获取常用标签
        this.getCommonUse()
        if (!sessionStorage.getItem("labelList")) {
          sessionStorage.setItem("labelList", JSON.stringify(labelList));
        }
        console.log(this.dataList,"dataList");
      });
    },
    // 获取常用标签
    getCommonUse(type){
        // 最近使用
        getLastUsed().then(res1=>{
          let recentlyRes = res1.data
          this.dataList.forEach((key, index) => {
            key.data.forEach((item, index2) => {
              item.data.forEach((label, index3) => {
                // 添加属性  是否为最近使用=>recently   是否设置为常用=>commonUse
                label.recently = false
                recentlyRes.forEach(labName=>{
                  if(label.labelName == labName) label.recently = true
                })
              });
            });
          });
          let recentlyList = []
          for(var i = 0; i < recentlyRes.length; i++){
            this.dataList.forEach((key) => {
              key.data.forEach((item) => {
                item.data.forEach((label) => {
                  if(label.labelName == recentlyRes[i]){
                    recentlyList.push(label)
                  }
                });
              });
            });
          }
          this.recentlyList = recentlyList
          console.log(recentlyList,'--------------------------->');
        })
        // 自定义设置
        getLastUsedCustom().then(res2=>{
          let commonUseRes = res2.data
          this.dataList.forEach((key, index) => {
              key.data.forEach((item, index2) => {
                item.data.forEach((label, index3) => {
                  // 添加属性  是否为最近使用=>recently   是否设置为常用=>commonUse
                  label.commonUse = false
                  commonUseRes.forEach(lab=>{
                    if(label.labelName == lab.labelName){
                      label.commonUse = true
                      label.id = lab.id
                    }
                  })
                });
              });
            });
          let commonUseList = []
          for(var i = 0; i < commonUseRes.length; i++){
            this.dataList.forEach((key) => {
              key.data.forEach((item) => {
                item.data.forEach((label) => {
                  if(label.labelName == commonUseRes[i].labelName){
                    // console.log(label);
                    commonUseList.push(label)
                  }
                });
              });
            });
          }
          this.commonUseList = commonUseList
          if(type == 1){
            this.$message.success("设为常用成功")
          }else if(type == 2){
            this.$message.success("已取消常用")
          }
        })
    },
    // 常用标签点击
    attrClickTop(label){
      let label1,item,labelItem;
      this.dataList.forEach(lab => {
        lab.data.forEach(lab2 => {
          lab2.data.forEach(lab3 => {
            if(lab3.labelName == label.labelName){
              item = lab
              labelItem = lab2
              label1 = lab3
            }
          })
        })
      })
      console.log(label);
      this.attrClick(label1, item, labelItem)
      // 常用标签下选中左侧常用标签，不选中原本的标签
      this.leftWarpTitle = '常用标签'
    },
    // 左侧属性列表点击
    attrClick(label, item, labelItem) {
      console.log(label,item,labelItem)
      // 选中左侧标签菜单
      this.leftWarpTitle = item.firstLevelCategory;
      if(item.firstLevelCategory == '互动标签' && !this.isOrderHd && labelItem.secondLevelCategory != '联合营销相关标签'){
        return this.$message.warning("使用互动标签需订购京获客，请订购后使用该标签~");
      }
      if((item.firstLevelCategory == '互动标签' && this.form.type ==1) || (item.firstLevelCategory != '互动标签' && this.form.type ==13)){
        return this.$message.warning("所选分类与标签不一致，请重新选择");
      }
      if(labelItem.secondLevelCategory == "联合营销相关标签" && !label.valueData.visible){
        // label.valueData.activityId = this.marketOptions[label.labelName][0].id
      }
      console.log(this.marketOptions,"marketOptions");
      if (label.isNew) {
        this.isNewNum++;
        label.isNew = false;
        if (this.isNewNum >= "5" && !this.isSaveLocation) {
          this.isSaveLocation = true;
          var days = new Date().getDate();
          localStorage.setItem("dotDays", days);
        }
      }
      label.valueData.visible ? this.selectLabelCount-- : this.selectLabelCount++;
      // 品类标签与其他标签而选择一
      if (!label.valueData.visible) {
        this.pinleiCategory.push(item.firstLevelCategory);
      } else {
        this.pinleiCategory.splice(this.pinleiCategory.indexOf(item.firstLevelCategory), 1);
      }

      let isPinlei = 1;
      const num = this.pinleiCategory.indexOf("品类标签");
      if (num == -1) {
        this.goodsPerantID = -111;
      }
      this.pinleiCategory.forEach((ele) => {
        if (ele != "品类标签") {
          isPinlei = 2;
        }
      });
      if (num != -1 && isPinlei == 2) {
        this.pinleiCategory.pop();
        this.selectLabelCount--;
        return this.$message.warning("店铺标签、品类标签、互动标签只能三选一，如选择，请删除已选标签再进行选择");
      } else {
        this.goodsPerantID == -111;
      }

      label.valueData.visible = !label.valueData.visible;
      if (labelItem.data.some((i) => i.valueData.visible)) {
        item.isShow = true;
      } else {
        item.isShow = false;
      }

      if (label.valueData.visible === false) {
        label.valueData.checkValue = []; //类型2
        label.valueData.minValue = []; //类型3
        label.valueData.maxValue = [];
        label.valueData.goodsList = [];
        label.valueData.itemInfo = [];
        label.valueData.skuInfo = [];
        label.valueData.value = [];
        label.valueData.startValue = "";
        label.valueData.endValue = "";
        label.valueData.maxTime = "";
        label.valueData.minTime = "";
        label.valueData.startMonth = "";
        label.valueData.startDay = "";
        label.valueData.endMonth = "";
        label.valueData.endDay = "";
        this.labels = 0; //类型5
        this.provinces = [];
        this.goodsClass = [];

        if (this.goodsPerantID == 1 || this.pinleiCategory.indexOf("品类标签") != -1) {
          this.goodsClass = this.goodsItem;
        }
        if (label.valueData.skuType) {
          label.valueData.skuType = 0;
        }
        const num1 = this.pinleiCategory.indexOf("品牌标签");
        if (num1 == -1) {
          this.brandsList = [];
        }
      }
      //判断表格是否为空
      try {
        this.dataList.forEach((item) => {
          item.data.forEach((item1) => {
            item1.data.forEach((item2) => {
              if (item2.valueData.visible == true) {
                throw new Error("End");
              } else {
                this.defaultShow = true;
              }
            });
          });
        });
      } catch (e) {
        if (e.message === "End") {
          this.defaultShow = false;
        } else {
          this.defaultShow = true;
        }
      }
    },
    setItem(key) {
      localStorage.setItem(key, JSON.stringify(new Date()));
    },
    // 保存按钮
    handleSave() {
      if (this.shake) { // 节流
        return
      }
      if (!this.form.name || !this.form.name.trim()) {
        this.$message.warning("请填写人群名称");
        return false;
      }
      if (!this.form.description || !this.form.description.trim()) {
        this.$message.warning("请填写人群描述");
        return false;
      }
      let strategy = this.showLimitAttr();
      // 类型品类 需要选择商品类目
      let catelist = [];
      if (this.goodsPerantID == -111 && this.pinleiCategory.indexOf("品类标签") != -1) {
        this.$message.warning("请选择品类标签的商品类目");
        return;
      } else {
        if (this.pinleiCategory.indexOf("品类标签") != -1) {
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                if (dataItem.firstLevelCategory == "品类标签") {
                  let obj = {};
                  if (this.goodpinpei == 1) {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  } else if (this.goodpinpei == 2) {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                    if (item.labelMeaning == "二级品类") {
                      obj.value = this.goodsClass.map((item) => {
                        let id = 0;
                        if (item.id) {
                          id = item.id;
                        } else {
                          id = item;
                        }
                        return id;
                      });
                      obj.group = item.labelGroup;
                      obj.tagname = item.labelName;
                      obj.type = item.labelParamEsType;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  } else {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                    if (item.labelMeaning == "三级品类") {
                      obj.value = this.goodsClass.map((item) => {
                        let id = 0;
                        if (item.id) {
                          id = item.id;
                        } else {
                          id = item;
                        }
                        return id;
                      });
                      obj.group = item.labelGroup;
                      obj.tagname = item.labelName;
                      obj.type = item.labelParamEsType;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  }
                }
              });
            });
          });
        }
        // param.value = item.goodsID;
      }

      // 选择品牌id判断
      let brand = [];
      if (this.brandsList.length == 0 && this.pinleiCategory.indexOf("品牌标签") != -1) {
        this.$message.warning("请选择品牌标签的品牌");
        return;
      } else {
        if (this.pinleiCategory.indexOf("品牌标签") != -1) {
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                if (dataItem.firstLevelCategory == "品牌标签") {
                  let obj = {};
                  if (item.labelMeaning == "品牌id") {
                    obj.value = this.brandsList;
                    obj.group = item.labelGroup;
                    obj.type = item.labelParamEsType;
                    obj.tagname = item.labelName;
                    obj.paramRules = String(item.labelParamRule);
                    brand.push(obj);
                  }
                }
              });
            });
          });
        }
      }
      console.log('this.form',this.form);
      const params = Object.assign(this.form, {
        strategy: JSON.stringify([...strategy, ...catelist, ...brand]),
        // type: 1,
      });
      if (!params.strategy) {
        return;
      }
      if (params.strategy != "[]") {
        console.log(params);
        this.shake = true;
        addMemberCrowd(params).then((res) => {
          this.shake = false;
          if (res && res.code == 1) {
            this.setItem("isFresh");
            this.$store.commit("setRefresh", true);
            this.successDaiLog = true
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("请编辑人群筛选条件");
      }
    },
    onChange(val) {
      if (val.length == 0) {
        this.inputWidth = 200;
      }
      if (val.length < 13) {
        return;
      }
      if (val.length - this.valLength > 25) {
        this.inputWidth = 240 + val.length * 10;
      }

      if (this.valLength < val.length) {
        this.inputWidth = 60 + val.length * 8;
      } else {
        this.inputWidth -= 9;
      }

      this.valLength = val.length;
    },

    // 计算人群按钮
    handlePeopleComputed() {
      const params = this.showLimitAttr();
      // 类型品类 需要选择商品类目
      let catelist = [];
      //计算人群线上bug处理------lin，10.17
      // let tagnameObj = {
      //   tagname:'item_first_cate_cd',
      //   group: "app_eco_user_cate_act",
      //   type: "terms",
      //   paramRules: "0"
      // }
      // tagnameObj.value = this.goodsClass.map((item) => {
      //                   let id = 0;
      //                   if (item.id) {
      //                     id = item.id;
      //                   } else {
      //                     id = item;
      //                   }
      //                   return id;
      // });
      //end
      if (this.goodsPerantID == -111 && this.pinleiCategory.indexOf("品类标签") != -1) {
        this.$message.warning("请选择品类标签的商品类目");
        return;
      } else {
        if (this.pinleiCategory.indexOf("品类标签") != -1) {
          //10.17
          // catelist.push(tagnameObj)
          //end
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                if (dataItem.firstLevelCategory == "品类标签") {
                  let obj = {};
                  if (this.goodpinpei == 1) {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  } else if (this.goodpinpei == 2) {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                    if (item.labelMeaning == "二级品类") {
                      obj.value = this.goodsClass.map((item) => {
                        let id = 0;
                        if (item.id) {
                          id = item.id;
                        } else {
                          id = item;
                        }
                        return id;
                      });
                      obj.group = item.labelGroup;
                      obj.tagname = item.labelName;
                      obj.type = item.labelParamEsType;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  } else {
                    if (item.labelMeaning == "一级品类") {
                      obj.value = [this.goodsPerantID];
                      obj.group = item.labelGroup;
                      obj.type = item.labelParamEsType;
                      obj.tagname = item.labelName;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                    if (item.labelMeaning == "三级品类") {
                      obj.value = this.goodsClass.map((item) => {
                        let id = 0;
                        if (item.id) {
                          id = item.id;
                        } else {
                          id = item;
                        }
                        return id;
                      });
                      obj.group = item.labelGroup;
                      obj.tagname = item.labelName;
                      obj.type = item.labelParamEsType;
                      obj.paramRules = String(item.labelParamRule);
                      catelist.push(obj);
                    }
                  }
          
                }
              });
            });
          });
        }
      }
      // 选择品牌id判断
      let brand = [];
      if (this.brandsList.length == 0 && this.pinleiCategory.indexOf("品牌标签") != -1) {
        this.$message.warning("请选择品牌标签的品牌");
        return;
      } else {
        if (this.pinleiCategory.indexOf("品牌标签") != -1) {
          this.dataList.forEach((dataItem) => {
            dataItem.data.forEach((labelItem) => {
              labelItem.data.forEach((item) => {
                if (dataItem.firstLevelCategory == "品牌标签") {
                  let obj = {};
                  if (item.labelMeaning == "品牌id") {
                    obj.value = this.brandsList;
                    obj.group = item.labelGroup;
                    obj.type = item.labelParamEsType;
                    obj.tagname = item.labelName;
                    obj.paramRules = String(item.labelParamRule);
                    brand.push(obj);
                  }
                }
              });
            });
          });
        }
      }
      if (params) {
        this.compLoading = true
        compute({ strategy: JSON.stringify([...params, ...catelist, ...brand]),type:this.form.type }).then((res) => {
          if (res && res.code == 1) {
            this.population = res.data.count;
          }else {
            this.$message.warning(res.message);
          }
          console.log(res);
          this.compLoading = false
        });
      }
    },
    // 取消按钮
    handleCancel(state) {
      if(state) this.successDaiLog = false
      this.$nextTick(()=>{
        state ? this.$emit("on-cancel", true) : this.$emit("on-cancel", false);
        this.form.name= "";
        this.form.description= "";
        this.form.type=1;
        this.form.classifyId=0;
        this.form.strategyId = '';
        this.form.precisionCrowdStrategyId = '';
        this.mangeQd = true, // 管理渠道
        this.batchDelId = [], // 批量删除id列表
        this.checkOfficialIdList = [], // 选中的官方渠道id
        this.checkedCustomId = [], // 已选自定义渠道id
        this.allSelectCustomId = [], // 自定义渠道id全选
        this.allSelectCustomIdDel = [], // 自定义渠道id全选-删除
        this.tabIndex = "1", // 渠道弹窗tab下标
        this.manualId = "", // 手动录入id
        this.pinleiCategory = [];
        this.goodpinpei = 0;
        this.goodsPerantID = -111; // 品类  一类ID
        this.selectLabelCount = 0;
        this.population = 0;
        this.dataList = [];
        this.brandsList = [];
        this.getLabelList();  
      })
      this.$router.push("/marketing/marketing/grouping")
      
    },
    // 删除标签
    delLabel(label, item, labelItem) {
      // console.log(label)
      label.valueData.visible = false;
      // 删除
      this.pinleiCategory.splice(this.pinleiCategory.indexOf(item.firstLevelCategory), 1);
      if (this.pinleiCategory.indexOf("品类标签") == -1) {
        this.goodsPerantID = -111;
        this.goodsItem = [];
      }
      console.log(this.pinleiCategory);
      if (labelItem.data.some((i) => i.valueData.visible)) {
        item.isShow = true;
      } else {
        item.isShow = false;
      }
      if (label.valueData.visible === false) {
        this.allSelectCustomId = []
        this.allSelectMembel = []
        this.checkedCustomId = []
        this.checkOfficialIdList = []
        label.valueData.checkValue = []; //类型2
        label.valueData.minValue = []; //类型3
        label.valueData.maxValue = [];
        label.valueData.goodsList = [];
        label.valueData.itemInfo = [];
        label.valueData.skuInfo = [];
        label.valueData.startValue = "";
        label.valueData.endValue = "";
        label.valueData.value = "";
        label.valueData.maxTime = "";
        label.valueData.minTime = "";
        label.valueData.startMonth = "";
        label.valueData.startDay = "";
        label.valueData.endMonth = "";
        label.valueData.endDay = "";
        if (label.valueData.skuType) {
          label.valueData.skuType = 0;
        }
        this.labels = 0; //类型5
        if (label.labelMeaning == "省市") {
          this.provinces = [];
        }
        if (item.firstLevelCategory != "品类标签") {
          this.goodsClass = [];
        }
        if (this.pinleiCategory.indexOf("品类标签") == -1) {
          this.goodsClass = [];
        }

        const num1 = this.pinleiCategory.indexOf("品牌标签");
        if (num1 == -1) {
          this.brandsList = [];
        }
      }
      this.selectLabelCount--;
      //判断表格是否为空
      try {
        this.dataList.forEach((item) => {
          item.data.forEach((item1) => {
            item1.data.forEach((item2) => {
              if (item2.valueData.visible == true) {
                throw new Error("End");
              } else {
                this.defaultShow = true;
              }
            });
          });
        });
      } catch (e) {
        if (e.message === "End") {
          this.defaultShow = false;
        } else {
          this.defaultShow = true;
        }
      }
    },
    arrayIndexOf(item, arr) {
      if (Array.prototype.indexOf) {
        return arr.indexOf(item);
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return i;
          }
        }
      }
      return -1;
    },
    // 属性限制过滤相关
    showLimitAttr() {
      // 获取勾选的属性的值
      var valueData = [];
      this.dataList.forEach((dataItem) => {
        dataItem.data.forEach((labelItem) => {
          labelItem.data.forEach((item) => {
            if (item.valueData.visible) {
              valueData.push({ ...item, brandID: dataItem.value, CategoryName: dataItem.firstLevelCategory });
            }
          });
        });
      });
      let tipText = "";
      let isFlag = true;
      let params = [];
      for (let i = 0; i < valueData.length; i++) {
        
        let item = valueData[i];
        let param = {};
        // 单选类型
        if (item.labelDisplayType == 0) {
          !item.valueData.value && ((tipText = item.labelMeaning + "：没有选择单选项"), (isFlag = false));
          param.value = item.valueData.value;
        }
        // 生日类型
        if (item.labelDisplayType == 10) {
          if(item.valueData.startMonth && item.valueData.startDay && item.valueData.endMonth && item.valueData.endDay){
            let start =  Number(item.valueData.startMonth + item.valueData.startDay.padStart(2,'0'))
            let end =  Number(item.valueData.endMonth + item.valueData.endDay.padStart(2,'0'))
            if(start <= end){
              param.startValue = item.valueData.startMonth + item.valueData.startDay.padStart(2,'0')
              param.endValue = item.valueData.endMonth + item.valueData.endDay.padStart(2,'0')
            }else{
              tipText = item.labelMeaning + "：起始日日期不得大于结束日期";
              isFlag = false;
              break;
            }

          }else{
            tipText = item.labelMeaning + "：不能为空";
            isFlag = false;
            break;
          }
        }
        // 复选框类型
        if (item.labelDisplayType == 1) {
          if (item.valueData.checkValue.length == 0 && item.labelExplain != "会员开卡的渠道") {
            tipText = item.labelMeaning + "：至少选一个";
            isFlag = false;
            break;
          }
          if (item.valueData.checkValue.length == 0 && this.checkedCustomId.length == 0 && this.InteractionID.length == 0 && item.labelExplain == "会员开卡的渠道") {
            tipText = item.labelMeaning + "：至少选一个";
            isFlag = false;
            break;
          }
          
          // 会员入会渠道
          if (item.labelName == "opdata_shop_member_channel") {
            var valueList = JSON.parse(JSON.stringify(item.valueData.checkValue));
            var delItem = [];
            valueList.forEach((vItem, checkIndex) => {
              if (vItem == "2,3,995,998") {
                // 2,3 测试渠道
                delItem.push(vItem);
                valueList.push("2");
                valueList.push("3");
                valueList.push("995");
                valueList.push("998");
              } else if (vItem == "212,213") {
                // 212,213 小程序领券入会
                delItem.push(vItem);
                valueList.push("212");
                valueList.push("213");
              } else if (vItem == "420,666") {
                // 420,666 联合开卡
                delItem.push(vItem);
                valueList.push("420");
                valueList.push("666");
              } else if (vItem == "1003,1004,1234") {
                // 1003,1004,1234 分享
                delItem.push(vItem);
                valueList.push("1003");
                valueList.push("1004");
                valueList.push("1234");
              } else if (vItem == "4021,4022,4023,402") {
                // 4021,4022,4023,402 社交魔方
                delItem.push(vItem);
                valueList.push("4021");
                valueList.push("4022");
                valueList.push("4023");
                valueList.push("402");
              } else if (vItem == "4031,403") {
                // 4031,403 大促活动
                delItem.push(vItem);
                valueList.push("4031");
                valueList.push("403");
              } else if (vItem == "4041,4042,404") {
                // 4041, 4042 锦鲤抽奖
                delItem.push(vItem);
                valueList.push("4041");
                valueList.push("4042");
                valueList.push("404");
              }
            });
            delItem.forEach((delItem, delIndex) => {
              valueList.splice(this.arrayIndexOf(delItem, valueList), 1);
            });
            // console.log('valueList', valueList);
            param.value = valueList;
          } else {
            param.value = item.valueData.checkValue;
          }
        }
        // 滑块类型
        if (item.labelDisplayType == 2) {
          !item.valueData.slideValue && ((tipText = item.labelMeaning + "：请滑动取值"), (isFlag = false));
          param.value = item.valueData.slideValue;
        }
        // 数字范围选择类型
        if (item.labelDisplayType == 3) {
          if (item.valueData.rangeType == "0") {
            // 区间
            if (item.valueData.minValue != "" && item.valueData.maxValue != "") {
              if (+item.valueData.minValue > +item.valueData.maxValue) {
                tipText = item.labelMeaning + "：开始值不能大于结束值";
                isFlag = false;
                break;
              }
            } else if (item.valueData.minValue + "" == "") {
              // console.log(item);
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.rangeType == "-1") {
            if (item.valueData.maxValue + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.rangeType == "1" && item.valueData.minValue == "") {
            tipText = item.labelMeaning + "：结束值不能为空";
            isFlag = false;
            break;
          }
          param.startValue = item.valueData.minValue;
          param.endValue = item.valueData.maxValue;
          if (param.endValue instanceof Array && param.endValue.length == 0) {
            param.endValue = "";
          }
          // 小于等于选项，startValue需要默认值0
          if (item.valueData.rangeType == "-1") {
            param.startValue = "0";
          }
        }
        // 时间范围选择类型
        if (item.labelDisplayType == 4) {
          // console.log(item.valueData.minTime, item.valueData.maxTime);
          if (item.valueData.rangeType == 0) {
            // 区间
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 2) {
            // 小于
            if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 1) {
            // 大于
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
          } else if (item.valueData.rangeType == 3) {
            if (item.valueData.minTime == "" && item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.minTime != "" && item.valueData.maxTime != "" && +item.valueData.minTime > +item.valueData.maxTime) {
              tipText = item.labelMeaning + "：开始值不可大于结束值";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else {
            if (item.valueData.value == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            }
            param.value = item.valueData.value.join(",");
          }
          param.timeSelectType = item.valueData.rangeType + "";
        }
        // 指定商品 指定
        if (item.labelDisplayType == 5) {
          if (item.valueData.skuType == 0) {
            item.valueData.goodsList.length == 0 && ((tipText = item.labelMeaning + "：请选择商品"), (isFlag = false));
            param.itemInfo = item.valueData.itemInfo;
            param.skuInfo = item.valueData.skuInfo;
            param.value = item.valueData.goodsList.map((i) => i + "");
          } else {
            !item.valueData.value.trim() && ((tipText = item.labelMeaning + ": 请输入商品sku"), (isFlag = false));
            param.value = item.valueData.value.split(",");
          }
        }
        // 商品类目
        if (item.labelDisplayType == 6) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少选择一项";
            isFlag = false;
          }
          param.value = item.valueData.value;
        }
        // 选择省市
        if (item.labelDisplayType == 7) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少选择一项";
            isFlag = false;
          }
          param.value = item.valueData.value;
        }
        // 输入框
        if (item.labelDisplayType == 8) {
          if (item.valueData.value == "") {
            tipText = item.labelMeaning + ": 请至少填写一个直播ID";
            isFlag = false;
          }
          param.value = item.valueData.value.split(",");
        }
        // 京获客活动 双下拉框
        if (item.labelDisplayType == 9) {
          item.valueData.activityType && (param.activityType = item.valueData.activityType);
          item.valueData.activityId && (param.activityId = item.valueData.activityId);
        }
        // 互动标签 - 参与指定活动
        if(item.labelName == "hd_join_select"){
          // 参与时间
          if (item.valueData.rangeType === 0) {
            // 区间
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 2) {
            // 小于
            if (item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          } else if (item.valueData.rangeType == 1) {
            // 大于
            if (item.valueData.minTime == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
          } else if (item.valueData.rangeType == 3) {
            if (item.valueData.minTime == "" && item.valueData.maxTime == "") {
              tipText = item.labelMeaning + "：不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.minTime != "" && item.valueData.maxTime != "" && +item.valueData.minTime > +item.valueData.maxTime) {
              tipText = item.labelMeaning + "：开始值不可大于结束值";
              isFlag = false;
              break;
            }
            param.startValue = item.valueData.minTime;
            param.endValue = item.valueData.maxTime;
            if (param.endValue instanceof Array && param.endValue.length == 0) {
              param.endValue = "";
            }
          }
          param.timeSelectType = item.valueData.rangeType + "";
          // 指定活动
          item.valueData.activityType && (param.activityType = item.valueData.activityType);
          item.valueData.activityId && (param.activityId = item.valueData.activityId);
          // 参与次数
          if (item.valueData.joinRangeType == "0") {
            // 区间
            if (item.valueData.join_start_value != "" && item.valueData.join_end_value != "") {
              if (+item.valueData.join_start_value > +item.valueData.join_end_value) {
                tipText = item.labelMeaning + "：开始值不能大于结束值";
                isFlag = false;
                break;
              }
            } else if (item.valueData.join_start_value + "" == "") {
              // console.log(item);
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            } else if (item.valueData.join_end_value + "" == "") {
              tipText = item.labelMeaning + "：结束值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.joinRangeType == "-1") {
            if (item.valueData.join_end_value + "" == "") {
              tipText = item.labelMeaning + "：开始值不能为空";
              isFlag = false;
              break;
            }
          } else if (item.valueData.joinRangeType == "1" && item.valueData.join_start_value == "") {
            tipText = item.labelMeaning + "：结束值不能为空";
            isFlag = false;
            break;
          }
          param.join_start_value = item.valueData.join_start_value;
          param.join_end_value = item.valueData.join_end_value;
          // 小于等于选项，startValue需要默认值0
          if (item.valueData.joinRangeType == "-1") {
            param.join_start_value = "0";
          }
        }
        // 互动标签 - 生日时间
        if(item.labelName == "hd_birth_time"){
          if(item.valueData.startMonth && item.valueData.startDay && item.valueData.endMonth && item.valueData.endDay){
            let start =  Number(item.valueData.startMonth + item.valueData.startDay.padStart(2,'0'))
            let end =  Number(item.valueData.endMonth + item.valueData.endDay.padStart(2,'0'))
            if(start <= end){
              param.startMonth = item.valueData.startMonth
              param.startDay = item.valueData.startDay
              param.endMonth = item.valueData.endMonth
              param.endDay = item.valueData.endDay
            }else{
              tipText = item.labelMeaning + "：起始日日期不得大于结束日期";
              isFlag = false;
              break;
            }
            
          }else{
            tipText = item.labelMeaning + "：不能为空";
            isFlag = false;
            break;
          }
        }
        // 互动活动参会列表
        if(item.labelName == "opdata_shop_interact_activitys"){
          console.log(item,"-==================item")
          if(item.valueData.mode == "1"){
            if(item.valueData.activityId.length == 0){
              tipText = "指定活动ID不能为空";
              isFlag = false;
              break;
            }
            if(item.valueData.activityId) {
              param.interactActivityIds = item.valueData.activityId.split(",")
            }else{
              param.interactActivityIds = []
            }
          }else{
            if(item.valueData.interactActivityIds[0] == ""){
              param.interactActivityIds = []
            }else{
              param.interactActivityIds = item.valueData.interactActivityIds;
            }
          }
          param.mode = item.valueData.mode;
          if(item.valueData.activityTypes[0] == ""){
            param.activityTypes = []
          }else{
            param.activityTypes = item.valueData.activityTypes;
          }
        }
        if (item.labelDisplayType == 11){
          param.activityId = item.valueData.activityId
        }
        param = Object.assign(param, {
          group: item.labelGroup,
          tagname: item.labelName,
          type: item.labelParamEsType,
          paramRules: String(item.labelParamRule),
        });
        params.push(param);
        params.map((item) => {
          if(item.tagname == "opdata_shop_member_channel") {
            this.checkedCustomId.map((item1) => {
              item1 = String(item1)
            })
            // 1.14迭代 点击计算
            this.InteractionID.map((it) => {
              it = String(it)
            })
            item.value = [...item.value, ...this.checkedCustomId, ...this.InteractionID]
          }
        })
      }
      if (!isFlag) {
        this.$message.warning(tipText);
        return;
      }
     
      return params;
    },
    // 标签名查询
    handleSearch() {
      this.searchStatus = true;
      let flag = false
      let list = [];
      this.dataList.forEach((dataItem) => {
        var i = 0;
        dataItem.data.forEach((labelItem) => {
          let j = 0;
          labelItem.data.forEach((item) => {
            if (item.labelMeaning.indexOf(this.searchValue) != "-1") {
              console.log('labelMeaning',item.labelMeaning)
              item.searchItem = true;
              list.push(dataItem);
              i++;
              j++;
              // 是否有常用标签
              if(item.recently) flag = true
              if(item.commonUse) flag = true
            } else {
              item.searchItem = false;
            }
          });
          j > 0 ? (labelItem.searchTitle = true) : (labelItem.searchTitle = false);
        });
        i > 0 ? (dataItem.searchWrap = true) : (dataItem.searchWrap = false);
      });

      // 锚点定位--默认定位常用标签，否则定位第一个标签
      if(flag){
        // 显示常用标签
        this.isCommonShow = true
        this.handleWrap({firstLevelCategory:'常用标签'});
      }else{
        // 隐藏常用标签
        this.isCommonShow = false
        list.length > 0 && this.handleWrap(list[0]);
      }
      console.log(this.dataList);
    },
    // 时间范围清楚
    clearTime(dataIndex, labelIndex, index) {
      var dataList = JSON.parse(JSON.stringify(this.dataList));
      let obj = dataList[dataIndex].data[labelIndex].data[index];
      dataList[dataIndex].data[labelIndex].data[index].valueData.minTime = "";
      dataList[dataIndex].data[labelIndex].data[index].valueData.maxTime = "";
      this.dataList = dataList;
      this.limitTimeRange(obj);
    },

    // 时间范围限制
    limitTimeRange(obj) {
      let timeRange = obj.labelSelectRange
      let stamp = 0
      let dataRange = new Date()
      if(timeRange == "近90天") stamp = 91
      if(timeRange == "近400天") stamp = 401
      if(timeRange == "近三年") stamp = 1096
      if(timeRange == "近1月") stamp = 31
      if(timeRange == "近1年" || timeRange == "近一年") stamp = 366
      if(timeRange == "近2年" || timeRange == "近两年") stamp = 731
      if(timeRange == "历史所有") stamp = 0
      if(stamp){
        dataRange.setDate(dataRange.getDate() - stamp);
        dataRange = dataRange.getTime()
      }
      this.$set(this.pickerOptionsList, "pickerOptions" + obj.labelName + "start", {
        disabledDate: (time) => {
          if (!obj.valueData.maxTime) {
            if(stamp){
              return time.getTime() > Date.now() || time.getTime() < dataRange;
            }else{
              return time.getTime() > Date.now();
            }
          } else {
            let endTime = new Date(obj.valueData.maxTime).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime;
            if(stamp){
              return time.getTime() > minTime || time.getTime() > Date.now() || time.getTime() < dataRange;
            }else{
              return time.getTime() > minTime || time.getTime() > Date.now();
            }
          }
        },
      });
      this.$set(this.pickerOptionsList, "pickerOptions" + obj.labelName + "end", {
        disabledDate: (time) => {
          if (!obj.valueData.minTime) {
            if(stamp){
              return time.getTime() > Date.now() || time.getTime() < dataRange;
            }else{
              return time.getTime() > Date.now();
            }
          } else {
            let startTime = new Date(obj.valueData.minTime).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            if(stamp){
              return (time.getTime() < startTime - 8.64e7 || time.getTime() > Date.now()) || time.getTime() < dataRange;
            }else{
              return (time.getTime() < startTime - 8.64e7 || time.getTime() > Date.now());
            }
          }
        },
      });
    },

    // 标签查询结果返回
    goBack() {
      this.dataList.forEach((dataItem) => {
        dataItem.searchWrap = true;
        dataItem.data.forEach((label) => {
          label.searchTitle = true;
          label.data.forEach((item) => {
            item.searchItem = true;
          });
        });
      });
      this.searchStatus = false;
      this.searchValue = "";
    },
    //品牌弹窗
    BrandCategory(index) {
      this.brandIndex = index;
      this.brandsList = this.brandsList
        ? this.brandsList.map((item) => {
            let obj = {};
            if (item.brandCd) {
              obj.brandCd = item.brandCd;
            } else {
              obj.brandCd = item;
            }
            return obj;
          })
        : [];
      this.pinpaiCategory = true;
    },
    // 关闭品牌
    handleBrantCategory(state, val) {
      this.pinpaiCategory = false;
      if (state) {
        this.dataList[this.brandIndex].value = val;
        this.brandsList = val;
      }
    },
    // 显示商品类目弹窗
    showCategoryDialog(dataIndex, labelIndex, index, value) {
      // console.log(dataIndex, labelIndex, index, value);
      this.currentIndex = [dataIndex, labelIndex, index];
      // debugger;
      if (value.length > 0) {
        var goodsClass = [];
        value.forEach((item) => {
          var temp = {
            id: item.id,
          };
          goodsClass.push(temp);
        });
      }
      this.goodsClass = goodsClass ? goodsClass : [];
      this.goodsCategoryDialog = true;
    },
    // 显示Pinlei类目弹窗
    Category(index) {
      this.goodsIndex = index;
      this.goodsSel = true;
      this.goodsClass = this.goodsClass
        ? this.goodsClass.map((item) => {
            let obj = {};
            if (item.id) {
              obj.id = item.id;
            } else {
              obj.id = item;
            }
            return obj;
          })
        : [];
      this.CategoryDialog = true;
    },
    // 关闭商品类目弹窗
    closeCategory(state, val) {
      this.goodsCategoryDialog = false;
      if (state) {
        this.dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[this.currentIndex[2]].valueData.value = val.map((i) => ({
          id: i.id,
        }));
        this.goodsClass = val;
        this.goodsItem = this.goodsClass;
      }
    },
    // 品类标签商品类目弹窗
    handleCategory(state, val) {
      this.CategoryDialog = false;
      if (state) {
        this.dataList[this.goodsIndex].value = val.children.map((i) => i.id);
        this.goodsPerantID = val.id;
        console.log(this.dataList);
        //二级品类判断
        if (val.type) {
          this.goodpinpei = val.type;
        }
        this.goodsClass = val.children;
        this.goodsItem = this.goodsClass;
      }
    },
    // 限制skuid 最多输入30个
    limitSkuId(dataIndex, labelIndex, index) {
      var value = this.dataList[dataIndex].data[labelIndex].data[index].valueData.value;
      var reg = /[^\d,，\s]/g;
      if (reg.test(value)) {
        value = value.replace(reg, "");
      }
      this.dataList[dataIndex].data[labelIndex].data[index].valueData.value = value.replace(/\s+/g, "");
    },

    getLocation(val, state) {
      this.dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[this.currentIndex[2]].valueData.value = val;
      this.provinces = val;
    },
    // 选择省市
    handleSelectCity(dataIndex, labelIndex, index) {
      this.currentIndex = [dataIndex, labelIndex, index];
      this.cityShow = true;
    },
    // 显示选择商品弹窗
    showSelectGoods(dataIndex, labelIndex, index) {
      console.log('venderType',this.venderType)
      this.currentIndex = [dataIndex, labelIndex, index];
      this.returnSelectGoods = this.dataList[dataIndex].data[labelIndex].data[index].valueData.itemInfo;
      this.selectGoodsSkuList = this.dataList[dataIndex].data[labelIndex].data[index].valueData.skuInfo;
      if(this.venderType){
        this.returnSelectGoods = [];
        this.selectGoodsSkuList = this.dataList[dataIndex].data[labelIndex].data[index].valueData.itemInfo;
      }
      this.goodsState = true;
    },
    // 商品组件回调
    selectGoodsChange(val,item) {
      this.goodsState = false;
      if (val) {
        let valArr = [];
        this.returnSelectGoods = val;
        var dataList = JSON.parse(JSON.stringify(this.dataList));
        dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[this.currentIndex[2]].valueData.itemInfo = val;
        
        val.forEach((i) => {
          if (i.skuList != 0 && !this.venderType) {
            i.skuList.forEach((ele) => {
              if (ele.skuId) {
                valArr.push(ele.skuId);
              } else {
                valArr.push(ele);
              }
            });
          }else if(this.venderType){
            valArr.push(i.skuId);
          }
        });
        // 
        let itemArr = []
        if(!this.venderType){
          this.selectGoodsSkuList = item;
          dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[this.currentIndex[2]].valueData.skuInfo = item;
          itemArr = item.map((i) => i.skuId);
        }
        dataList[this.currentIndex[0]].data[this.currentIndex[1]].data[this.currentIndex[2]].valueData.goodsList = this.unique(itemArr, valArr);
        this.dataList = dataList;
      }
      
    },
    unique(arr, arr1) {
      let list = arr.filter((item) => item);
      let listArr = list.map((item) => Number(item));
      let list1 = arr1.filter((item) => item);
      let listArr1 = list1.map((item) => Number(item));
      console.log(listArr, listArr1);
      return [...new Set([...listArr, ...listArr1])];
    },
    // 继续创建
    continueCreate(){
      this.successDaiLog = false;
      // 线上Bug:点击继续创建删除precisionCrowdStrategyId为创建人群而非编辑
      this.form = {
        name: "",
        description: "",
        type:1,
        classifyId:0,
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attrActive {
  display: none !important;
}

.icon-dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #f56c6c;
  border-radius: 50%;
  vertical-align: 10%;
}
/deep/ .form-value .el-input__suffix {
  right: -45px;
}
.filter-box {
  padding: 20px;
  .filter-content {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background-color: #fff;
    padding: 20px 28px 0 28px;
    .search-form {
      .form-item {
        display: inline-block;
        // margin-right: 20px;
        .form-label {
          display: inline-block;
          text-align: right;
          width: 98px;
        }
        .form-value {
          display: inline-block;
        }
      }
      .form-right {
        float: right;
        span {
          margin-right: 12px;
        }
      }
      &::after {
        content: "";
        clear: both;
        display: block;
        width: 0;
        height: 0;
        overflow: hidden;
      }
    }
  }

  .attr-box {
    position: relative;
    height: 700px;
    margin-top: 10px;
    padding: 20px 28px 20px 28px;
    font-size: 14px;
    border: 1px solid #efefef;
    height: calc(100vh - 276px);
    overflow: hidden;
    .attr-leftbigProbox {
      display: inline-block;
      vertical-align: text-top;
      position: absolute;
      left: 0;
      right: 0;
      width: 200px;
      height: calc(100% - 20px);
      padding: 0 10px;
      border-right: 1px solid #efefef;
      .search-line {
        margin-bottom: 10px;
        position: relative;
        width: 100%;
        /deep/.el-input {
          input {
            border-radius: 32px;
          }
        }
        i {
          color: #cccccc;
          font-size: 14px;
          line-height: 32px;
          position: absolute;
          right: 10px;
          top: 0;
          cursor: pointer;
        }
      }
      .attr-leftbigTabbox {
        height: calc(100% - 42px);
        overflow: auto;
      }
      .attr-itemPro-wrap {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
      }
      .attr-itemPro-wrapClick {
        background-color: #fff6f5;
        color: #fe756e;
      }
      .attr-itemPro-wrap:hover {
        background-color: #fff6f5;
        color: #fe756e;
      }
    }
    .attr-leftbigbox {
      box-sizing: border-box;
      padding-right: 20px;
      position: absolute;
      left: 220px;
      height: 100%;
      .search-line {
        margin-bottom: 10px;
        position: relative;
        width: 360px;
        /deep/.el-input {
          input {
            border-radius: 32px;
          }
        }
        i {
          color: #cccccc;
          font-size: 14px;
          line-height: 32px;
          position: absolute;
          right: 10px;
          top: 0;
          cursor: pointer;
        }
      }
      .attr-left {
        // display: inline-block;
        box-sizing: border-box;
        padding-right: 20px;
        position: absolute;
        width: 390px;
        // max-height: 638px;
        height: 100%;
        overflow-y: auto;
        .search-result {
          padding-bottom: 10px;
          padding-top: 15px;
          border-bottom: 1px solid #eeeeee;
          display: flex;
          justify-content: space-between;
          color: #333;
          .go-back {
            color: rgb(254, 77, 69);
            cursor: pointer;
          }
        }
        .attr-item-wrap {
          box-sizing: border-box;
          border: 1px solid #eeeeee;
          padding: 0 8px;
          margin-bottom: 20px;
          h4 {
            height: 40px;
            line-height: 38px;
            border-bottom: 1px solid #f0f0f0;
            margin: 0;
            text-align: center;
            font-weight: bold;
            font-size: 14px;
            color: #333;
          }
        }
        .attr-item-box {
          margin-bottom: 7px;
          .attr-title {
            // height: 45px;
            // line-height: 45px;
            color: #333;
            font-weight: 500;
            padding-bottom: 10px;
            padding-top: 15px;
            // background-color: #f4f5f9;
            // padding-left: 20px;
          }
          .attr-list {
            padding-top: 5px;
            .over-ellipsis {
              height: 32px;
              line-height: 32px;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
            }
            .attr-padd {
              box-sizing: border-box;
              width: 50%;
              height: 32px;
              line-height: 32px;
              cursor: pointer;
              display: inline-block;
              position: relative;
              color: #333;
              text-align: center;
              margin: 0 0 8px 0;
              &:nth-child(1n) {
                padding: 0 5px 0 0;
              }
              &:nth-child(2n) {
                padding: 0 0 0 5px;
              }
              .attr-item {
                position: relative;
                box-sizing: border-box;
                padding: 0 5px;
                background-color: #f6f6f6;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                img {
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  display: none;
                }
                &.active {
                  color: #fe4d45;
                  border: 1px solid #fe4d45;
                  background-color: #fff;
                  .over-ellipsis {
                    color: #fe4d45;
                  }
                  img {
                    display: block;
                  }
                }
              }
            }
          }
        }
      }
    }
    .attr-rightbigbox {
      display: inline-block;
      vertical-align: text-top;
      // border: 1px solid #efefef;
      position: absolute;
      left: 650px;
      right: 0;
      height: 100%;
      .tip-line {
        color: #333;
        margin-bottom: 10px;
        .icon_i {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 14px;
          background-color: #fe8f8a;
          // vertical-align: middle;
          color: #fff;
          font-size: 14px;
          text-align: center;
          line-height: 14px;
          font-weight: bold;
          margin-right: 8px;
        }
      }
      .attr-right {
        display: inline-block;
        vertical-align: text-top;
        // border: 1px solid #efefef;
        position: absolute;
        left: 0px;
        right: 0;
        max-height: 638px;
        overflow: auto;
        height: calc(100% - 82px);
        // background-color: #000;
        .module-title {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          padding: 16px 0;
          border-bottom: 1px solid #eeeeee;
          margin-bottom: 20px;
        }
        .first-title {
          color: #666666 !important;
          font-size: 14px !important;
          line-height: 17px !important;
          margin-left: 10px !important;
          margin-top: 14px !important;
        }
        .attr-content-item {
          box-sizing: border-box;
          padding-right: 22px;
          position: relative;
          margin-bottom: 16px;
          .del-btn {
            position: absolute;
            right: -64px;
            top: 31px;
            cursor: pointer;
            i {
              font-size: 33px;
              color: #cccccc;
            }
          }

          .title-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 48px;
            padding: 0 28px 0 20px;
            background-color: #f6f6f6;
            color: #333;
            .handle {
              display: flex;
              align-items: center;
              .assistant {
                margin-right: 16px;
                width: 98px;
                height: 28px;
                line-height: 26px;
                background: #ffffff;
                border: 1px solid #fe4d45;
                border-radius: 3px;
                outline: none;
                color: #fe4d45;
                cursor: pointer;
                transition: all 0.3s;
                &:hover {
                  background-color: #fe4d45;
                  color: #fff;
                  opacity: 0.8;
                }
              }
              .delTxt {
                color: #fe4d45;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }
          .labelExplain {
            box-sizing: border-box;
            margin: 0;
            padding: 10px 0;
            border-bottom: 1px solid #eeeeee;
            line-height: normal;
            color: #999999;
            font-size: 13px;
          }
          .radio-content {
            line-height: 48px;

            .select-qd {
              color: #333333;
              padding-right: 8px;
            }

            /deep/ .el-dialog {
              position: relative;
              margin: 0 auto 50px;
              background: #FFFFFF;
              border-radius: 2px;
              -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              width: 50%;
              height: 560px;
            } 

            /deep/ .el-dialog__body {
              padding: 16px 30px;
              color: #606266;
              font-size: 14px;
              word-break: break-all;
            }

            .tab-line {
              font-size: 14px;
              color: #666666;
              border-bottom: 1px solid #dddddd;
              line-height: 34px;

              .tab-item {
                // padding: 15px 0;
                text-align: center;
                width: 106px;
                height: 36px;
                line-height: 36px;
                display: inline-block;
                position: relative;
                cursor: pointer;
                margin-right: 2px;
                border: 1px solid #dddddd;
                border-bottom: none;

                // &:first-child{
                //   margin-right: 22px;
                // }
                span {
                  position: absolute;
                  width: 100%;
                  left: 50%;
                  height: 2px;
                  transform: translateX(-50%);
                  bottom: -2px;
                  display: none;
                }

                &.active {
                  border-top: 2px;

                  span {
                    display: block;
                    background: #fff;
                  }
                }
              }
            }

            .manual-input-box {
              padding: 12px;
              border: 1px solid #EEEEEE;
              background-color: #F9FAFB;
              border-radius: 6px;
              width: 67%;

              .manual-submit-btn {
                width: 76px;
                height: 28px;
                text-align: center;
                line-height: 28px;
                color: #FE4D45;
                background-color: #FFF6F6;
                border: 1px solid #FE4D45;
                margin-top: 8px;
                cursor: pointer;
                border-radius: 2px;
              }

              /deep/ .el-textarea__inner {
                display: block;
                resize: vertical;
                padding: 5px 15px;
                line-height: 1.5;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                font-size: inherit;
                color: #333;
                background-color: #FFFFFF;
                background-image: none;
                border: 1px solid #EEEEEE;
                border-radius: 0px;
                -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
                transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
              }
            }

            .title {
              color: #fe4d45;
              padding-right: 100px;
              line-height: 22px;
              position: relative;
              margin: 16px 0 12px;
              position: relative;
              padding-left: 8px;

              &::before {
                position: absolute;
                top: 2px;
                left: 0;
                content: "*";
                color: #fe4d45;
              }

              .manage-qd {
                cursor: pointer;
                position: absolute;
                top: 0;
                right: 0;
                color: #7f85e9;
                display: flex;
                align-items: center;

                img {
                  margin-right: 6px;
                  vertical-align: middle;
                }
              }
            }

            .checked-box {
              min-height: 550px;
              .title-box {
                color: #333333;
                background-color: #F6F6F6;
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                line-height: 1;
                padding: 16px 16px 14px;

                span {
                  color: #7F85E9;
                }

                .clear {
                  display: flex;
                  align-items: center;
                  cursor: pointer;

                  span {
                    color: #FE4D45;
                  }

                  img {
                    width: 20px;
                    height: 20px;
                  }
                }
              }

              .checked-content {
                border-left: 1px solid #F6F6F6;
                border-right: 1px solid #F6F6F6;
                border-bottom: 1px solid #F6F6F6;
                padding: 14px 16px;
                max-height: 120px;
                overflow: auto;

                .checked-item {
                  box-sizing: border-box;
                  position: relative;
                  display: inline-block;
                  min-width: 100px;
                  text-align: center;
                  padding: 6px 6px;
                  line-height: 1;
                  color: #999999;
                  border: 1px solid #CCCCCC;
                  border-radius: 2px;
                  margin-right: 16px;
                  margin-bottom: 10px;
                  img {
                    cursor: pointer;
                    position: absolute;
                    top: 0;
                    right: 0;
                    transform: translate(50%, -50%);
                    width: 16px;
                    height: 16px;
                  }
                }
              }
            }

            .custom-del {
              position: absolute;
              right: 0;
              bottom: -40px;

              .assistant {
                width: 98px;
                height: 28px;
                line-height: 26px;
                background: #ffffff;
                border: 1px solid #fe4d45;
                border-radius: 3px;
                outline: none;
                color: #fe4d45;
                cursor: pointer;
                transition: all 0.3s;
                &:hover {
                  background-color: #fe4d45;
                  color: #fff;
                  opacity: 0.8;
                }
              }
            }

            .content-box {
              position: relative;
              height: 525px;
              overflow: auto;

              .all-check {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 999;
              }

              .flex-box-checkBox {
                display:flex; 
                flex-wrap: wrap;

                /deep/ .el-checkbox {
                  color: #606266;
                  font-weight: 500;
                  font-size: 14px;
                  position: relative;
                  cursor: pointer;
                  display: inline-block;
                  white-space: nowrap;
                  -webkit-user-select: none;
                  -moz-user-select: none;
                  -ms-user-select: none;
                  user-select: none;
                  margin: 0 30px 16px 0;
                  height: 14px;

                  &:nth-child(1) {
                    opacity: 0;
                  }
                }
              }
            }

            .tips-box {
              margin-top: 12px;
              padding: 12px;
              background-color: #FAFAFA;
              border-radius: 3px;
              width: 67%;
              line-height: 1;

              .tips-icon {
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 0 4px 0 3px;
                vertical-align: top;
              }

              .tips-content {
                display: inline-block;
                margin-left: 2px;
                color: #333333; 
                font-size: 13px;
                line-height: 13px;

                p {
                  &:nth-child(2) {
                    margin: 10px 0;
                  }
                }
              }
            }
          }
          .area-select {
            padding-top: 8px;
            padding-bottom: 8px;
            .to-text {
              margin: 0 8px;
            }
            .el-input {
              width: 125px;
            }
            .el-select {
              margin-right: 20px;
              width: 136px;
            }
          }
          .select-city-box {
            padding-top: 8px;
            padding-bottom: 8px;
            /deep/ .el-button {
              width: auto !important;
            }
          }
          .goods-sku-box {
            padding-top: 8px;
            padding-bottom: 8px;
            /deep/ .el-button {
              width: auto !important;
            }
            span {
              margin-right: 8px;
            }
          }
          .birth-input{
            .el-input {
              width: 80px;
            }
          }
          // .designated-goods {
          //   span {
          //     margin-right: 8px;
          //   }
          //   .el-input {
          //     width: 280px;
          //   }
          // }
          .content {
            padding-left: 20px;
            border: 1px solid #f6f6f6;
            .birth-input{
            .el-input {
              width: 80px;
            }
          }
          }
          .slider.content {
            padding-left: 38px;
            padding-top: 8px;
            padding-bottom: 8px;
          }
          .time-range {
            padding-top: 8px;
            padding-bottom: 8px;
            // .el-input{
            //   width: 240px;
            // }
            // .to-text{
            //   padding: 0 8px;
            // }
            // /deep/.el-input__inner{
            //   padding-left: 30px!important;
            //   box-sizing: border-box;
            // }
          }
        }
        .attr-content-item:first-child {
          margin-top: 16px;
        }
      }
    }
  }
}
.tree-box {
  max-height: 300px;
  overflow: auto;
}
.btn-group {
  position: absolute;
  right: 30px;
  bottom: -100px;
  text-align: right;
  .el-button {
    width: 96px;
  }
}
/**  底部计算保存按钮 */
.footer-btn-box {
  height: 80px;
  padding: 23px 0 21px 28px;
  background-color: #fff;
  font-size: 14px;
  .text-label {
    display: inline-block;
    vertical-align: middle;
    color: #333;
  }
  .computed-btn {
    width: 82px;
    height: 28px;
    vertical-align: middle;
    margin-right: 8px;
    color: #fe4d45;
    background-color: #fff;
    border: 1px solid #fe4d45;
    &:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }
  }
  .cancel-btn {
    width: 148px;
    height: 36px;
    // margin-left: 314px;
    color: #666666;
    float: right;
    background-color: #fff;
    border: 1px solid #dddddd;
    &:hover {
      color: #fe4d45;
      background-color: #fff4f4;
      border: 1px solid #fe4d45;
    }
  }
  .save-btn {
    width: 188px;
    height: 36px;
    float: right;
    margin-left: 8px;
    color: #fff;
    margin-right: 25px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
    }
  }
}
.buttonBox{
  .cancel-btn {
    color: #666666;
    background-color: #fff;
    border: 1px solid #dddddd;
    &:hover {
      color: #fe4d45;
      background-color: #fff4f4;
      border: 1px solid #fe4d45;
    }
  }
  .save-btn {
    padding-left: 20px;
    color: #fff;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
    }
  }
}
.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;
    // height: 80px;
    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }

  .btn-group1 {
    margin-top: 30px ;
    text-align: center ;
    /deep/ .el-button{
      width: 107px;
    }
  }
}
.popoverWrap {
  .popoverItem {
    display: flex;
    // align-items: center;
    margin: 20px;
    &:last-child {
      margin: 20px;
    }
    img {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .desc {
      display: flex;
      flex-direction: column;
      span {
        &:first-child {
          font-size: 16px;
          color: #000;
          margin-bottom: 2px;
        }
        &:last-child {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}

.noData{
  img{
    margin-left: 100px;
    margin-top: 93px;
  }
}



.datePicker {
  /deep/.el-input__inner {
    text-indent: 20px !important;
  }
}
</style>
<style lang="scss">
  .tip .el-message-box__content {
    padding-left: 60px !important;
  }
  .el-message-box__content {
    padding: 20px 0 !important;
    padding-left: 80px !important;
    text-align: left !important;
  }

  .el-popover{
    min-width: 100px !important;
  }
  .popoverSet{
    height: 40px;
    margin-left: -1px !important;
    // z-index: 0;
    // transition: none !important;
    transition-duration: 50ms !important;
    transition-delay: 10ms !important;
    img{
      width: 18px;
      height: 18px;
      position: relative;
      top: 3px;
      margin-right: 1px;
    }
    .tips{
      margin-top: -5px;
      font-size: 12px;
      span{
        cursor: pointer;
      }
      .noCommon{
        color: #7F85E9;
      }
      .common{
        color: #666666;
      }
    }
  }
  .toolTipSet{
    // transition: none!important;
    transition-duration: 0ms!important;
    transition-delay: 0ms!important;
  }
  .popoverTips{
    height: 42px;
  }
</style>
